/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useMemo } from "react";
import { Box, Button, Card, CardActions, CardContent, CardHeader, Collapse, Divider, Grid, Icon, Paper, Popover, TablePagination, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { orange } from "@mui/material/colors";
import { useCallback, useEffect, useState } from "react";
import adminStore from "src/store/AdminStore";
import theme from "src/theme/light";
import {PrioridadeType, Projeto } from "./types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil, faListDots, faInfoCircle, faClone, faFilter, faCopy } from "@fortawesome/free-solid-svg-icons";
import { DEFAULT_PROJETO, ETAPAS_LIST, SEGMENTO_LIST, SITUACAO_PAGAMENTOS_LIST } from "./constants";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { FilterDrawer } from "./containers/FilterDrawer";
import { buscaTipoDePropostaDeAcordoComPermissao, ModalDetalhes } from "./ModalDetalhes";
import { ModalAlterarServico } from "./acoes/alterarServico/ModalAlterarServico";
import MenuItemAcao, { MenuAcao, TipoExibicao } from './MenuItemAcao';
import { checarStatusAcao, checarStatusDetalhesProjeto, checarStatusEditarProjeto, checarStatusAcoesProjeto, tipoAvulso } from "./utils/checarStatusAcao";
import { formState$ } from "src/store/vendas/projetos/store";
import { useHistory } from "react-router-dom";
import { ModalVisualizarProposta, TiposVisualizacaoProposta } from "./acoes/visualizarProposta/ModalVisualizarProposta";
import { ModalFinalizar } from "./acoes/finalizar/ModalFinalizar";
import { ConfirmarVisita } from "./acoes/visita";
import { ModalCancelarProjeto } from "./acoes/cancelarProjeto/ModalCancelarProjeto";
import { EnviarNota } from "./acoes/enviarNota";
import { ModalAplicarDesconto } from "./acoes/alterarDesconto/ModalAplicarDesconto";
import { ModalEnviarDocumentosServico } from "./acoes/enviarDocumentosServico";
import { EnviarPagamento } from "./acoes/enviarPagamento";
import { ModalReativarProposta } from "./acoes/reativarProposta/ModalReativarProposta";
import { AvatarTipo } from "./AvatarTipo";
import { useObservable } from "src/framework/store/storeUtil";
import { estadosServicoRegioes$, getCategoriasComponentes, getEstadosServicoRegioes, getUpload, mensagemWhatsAppProposta$, resolveProtocolUrl, resolveUploadUrl, verificarSegmentoConta } from "src/store/global.store";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { useFilters } from "src/framework/layouts/Main/FiltersContext";
import { MENSAGEM_OBSERVACAO_CANCELADO, MENSAGEM_OBSERVACAO_EXPIRADO } from "src/constants";
import { Empty } from "./Empty";
import ItemMenuEnviarNota from "./utils/itemMenuEnviarNota";
import { differenceInCalendarDays } from "date-fns";
import api, { apiNoMessageError, IDataRequest, STATUS_CODE } from "src/framework/providers/api";
import { ModalCancelamentoEspecial } from "./acoes/modalCancelamentoEspecial/ModalCancelamentoEspecial";
import { ModalAtualizarEntrega } from "./acoes/modalAtualizarEntrega/ModalAtualizarEntrega";
import { ModalReenviarNotaFiscal } from "./acoes/modalReenviarNotaFiscal/ModalReenviarNotaFiscal";
import { CustomLoader } from "./customLoader";
import { ModalFinalizarProjetoManual } from "./acoes/modalFinalizarProjetoManual/ModalFinalizarProjetoManual";
import { ComponenteClonagem, ModalClonarProjeto, RequestClonagem } from "./acoes/modalClonarProjeto/ModalClonarProjeto";
import { ComponentePrevisao } from "./dimensionados/containers/ModalFinalizar";
import { ModalRevendaServicoDesabilitado } from "./containers/ModalRevendaServicoDesabilitado";
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {CopyToClipboard} from "react-copy-to-clipboard";
import { notifierStore } from "src/framework/store/NotifierStore";
import { LoginStore } from "src/framework/store/LoginStore";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { CollectionUtil } from "src/framework/commons/CollectionUtil";
import { DateUtil } from "src/framework/commons/DateUtils";
import { MAIN_APP_CONTAINER_ID } from "src/framework/layouts/Main";
import { AcoesSugeridas, SugestaoAcoes } from "./sugestoes";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { WhatsAppUtil } from "src/framework/commons/WhatsAppUtil";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { TipoPropostaModal } from "./containers/ModalTipoProposta";
import { Pedido } from "../vendas/types";

export const FORMA_PAGAMENTO_BOLETO = 1;
export const FORMA_PAGAMENTO_CARTAO_CREDITO = 2;
export const FORMA_PAGAMENTO_FINANCIAMENTO = 3;
export const FORMA_PAGAMENTO_CARTA_CREDITO = 4;
export const FORMA_PAGAMENTO_BOLETO_CARTAO_CREDITO = 5;
export const FORMA_PAGAMENTO_BOLETO_FINANCIAMENTO = 6;
export const FORMA_PAGAMENTO_CARTAO_CREDITO_FINANCIAMENTO = 7;
export const FORMA_PAGAMENTO_PIX = 8;
export const FORMA_PAGAMENTO_PIX_CARTAO_CREDITO = 9;
export const FORMA_PAGAMENTO_BOLETO_CARTA_CREDITO = 10;
export const FORMA_PAGAMENTO_CARTAO_CARTA_CREDITO = 11;
export const FORMA_PAGAMENTO_PIX_FINANCIAMENTO = 12;
export const FORMA_PAGAMENTO_PIX_CARTA_CREDITO = 13;
export const FORMA_PAGAMENTO_CARTA_CREDITO_FINAME = 14;
export const FORMA_PAGAMENTO_VAREJO = 15;

export const FORMAS_FINANCIAMENTOS_INDIRETOS = [
    FORMA_PAGAMENTO_CARTA_CREDITO,
    FORMA_PAGAMENTO_PIX_CARTA_CREDITO,
    FORMA_PAGAMENTO_BOLETO_CARTA_CREDITO,
    FORMA_PAGAMENTO_CARTAO_CARTA_CREDITO,
    FORMA_PAGAMENTO_CARTA_CREDITO_FINAME
]
export const FORMAS_FINANCIAMENTOS_DIRETOS = [
    FORMA_PAGAMENTO_FINANCIAMENTO,
    FORMA_PAGAMENTO_BOLETO_FINANCIAMENTO,
    FORMA_PAGAMENTO_CARTAO_CREDITO_FINANCIAMENTO,
    FORMA_PAGAMENTO_PIX_FINANCIAMENTO
]
export const FORMAS_PAGAMENTO_UNICO = [
    FORMA_PAGAMENTO_BOLETO,
    FORMA_PAGAMENTO_CARTAO_CREDITO,
    FORMA_PAGAMENTO_FINANCIAMENTO,
    FORMA_PAGAMENTO_CARTA_CREDITO,
    FORMA_PAGAMENTO_PIX,
    FORMA_PAGAMENTO_VAREJO,
];
export interface UsersIntelbras {
    id: number;
  }

export const parsePrioridadeProjeto = (status: PrioridadeType): string => {
    switch (status) {
        case "media":
            return "Média";
        case "alta":
            return "Alta";
        default:
            return "Baixa";
    }
}

export const parsePrioridadeProjetoColor = (status: PrioridadeType): any => {
    switch (status) {
        case "media":
            return orange[200];
        case "alta":
            return theme.palette.primary.light;
        default:
            return null;
    }
}

export const parseStatusProjetos = (status: any, texto: string) =>{
    switch (status){
        case "pre_orcamento":
            return  texto === 'cor' ? "#1857d2" : "Pré-orçamento";
        case "proposta_final":
            return texto === 'cor' ? "#627f87" : "Proposta Final";
        case "cancelado":
            return  texto === 'cor' ? "#cc1414" : "Projeto Cancelado";
        case "pagamento_reconhecido":
            return texto === 'cor' ? "#4caf50" : "Pagamento Reconhecido";
        case "processando_informacoes_pedido":
            return texto === 'cor' ? "#cc8f00" : "Processando Informações do Pedido";
        case "em_transito":
            return  texto === 'cor' ? "#9c27b0" : "Em Trânsito";
        case "entregue":
            return  texto === 'cor' ? "#00695c" : "Produto Entregue";
        case "finalizado":
            return  texto === 'cor' ? "#2e7d32" : "Projeto Finalizado";
    }
}
export const parseSituacoesPagamento = (situacao: any, formaPagamento?: string, financiamento?: any) => {
    // validação para situação de financiamento SOL-1210
    if(financiamento){
        if(financiamento.situacao_financiamento === "emissao_nota" && financiamento?.aguardando_pagamento){
            return "Aguardando Pagamento";
        }

        switch(financiamento.situacao_financiamento){
            case "aguardando_pagamento":
                return "Aguardando confirmação do pagamento";
            case "emissao_nota":
                return "Aguardando emissão da NF";
            case "solicitar_assinatura":
            case "assinatura":
            case "planos":
            case "proposta":
                return "Em análise de financiamento"; 
            case "pago":
                return "Pago";
            case "aguardando_pagamento_complemento":
                return "Aguardando Pagamento";
        }
    }

    if (formaPagamento && formaPagamento === 'varejo' && (situacao === "emissao_nota_varejo")) {
        return 'Aguardando emissão de Nota Fiscal';
    }

    switch (situacao){
        case "pago":
            return "Pago";
        case "finalizado":
            return "Pago"
        case "parcialmente_pago":
            return "Parcialmente pago";
        case "carta_credito":
            return "Aguardando análise de documento";
        case "aguardando_pagamento":
            return "Aguardando Pagamento";
        case "aguardando_analise_documentacao":
            return "Aguardando análise da documentação";
        case "aguardando_emissao_nf":
        case "emissao_nota":
            return "Aguardando emissão da NF";
        case "comprovante_pagamento_pendente":
            return "Aguardando confirmação do pagamento";
        case "comprovante_pagamento":
            return "Aguardando análise do comprovante";
        case "recusado":
            return "Recusado";
        case "erro":
            return "Recusado";
        case "cancelado":
            return "Cancelado";
        case "aguardando_confirmacao_pagamento":
            return "Aguardando confirmação do pagamento";
        case "analise_financiamento":
            return "Em análise de financiamento";
        case "expirado":
            return "Expirado";
        case "pendente":
            return "Aguardando Pagamento";
        case "solicitar_assinatura":
            return "Aguardando assinatura do contrato";
        case "assinatura":
            return "Aguardando assinatura do contrato";
        default:
            return "-";
    }
}

export const formatarStatusPagamento = (projeto: any, pedido: any) => {
    if (projeto?.status_projeto === 'cancelado') return parseSituacoesPagamento('cancelado')

    const historicoList = pedido?.pagamentos_historico?.length ? [...pedido.pagamentos_historico] : []
    const pagamentoHistorico = historicoList.sort(CollectionUtil.singleSort('-data_atualizacao_pagamento'))
    const historicoItemAtual = pagamentoHistorico[0]

    if (historicoItemAtual?.dados_integracao?.cartao_credito?.length > 1) return parseSituacoesPagamento(projeto?.status_projeto_pagamento)

    const keys = Object.keys(historicoItemAtual?.dados_integracao || {})
    const todasSituacoes: string[] = []
    keys.forEach(key => {
        const dado = historicoItemAtual?.dados_integracao[key]
        if (dado?.length) {
            todasSituacoes.push(...dado?.map((d: any) => {
                if (d.situacao === 'recusado' && d.observacao === MENSAGEM_OBSERVACAO_EXPIRADO) return 'expirado'
                if (d.situacao === 'recusado' && d.observacao === MENSAGEM_OBSERVACAO_CANCELADO) return 'cancelado'
                return d.situacao
            }))
        }
    })

    if (todasSituacoes.length > 1) {
        if (todasSituacoes?.includes('cancelado') && todasSituacoes?.includes('recusado')) return parseSituacoesPagamento('cancelado');
        // Se for pagamento combinado com financiamento externo, e a segunda forma for recusada/recusado, deve exibir cancelado
        const cartaCredito = historicoItemAtual?.dados_integracao?.carta_credito;
        if (cartaCredito?.length) {
            const statusBloqueado = ['cancelado','expirado','recusado'];
            const statusProjetoPagamento = projeto?.status_projeto_pagamento || '';
            const statusProjetoPagamentoBloqueado = statusBloqueado?.includes(statusProjetoPagamento)
            const formaPagamentoId =  pedido?.forma_pagamento?.id
            const situacao = cartaCredito[0]?.situacao;
            if (statusProjetoPagamentoBloqueado && !statusBloqueado?.includes(situacao) && !FORMAS_PAGAMENTO_UNICO.includes(formaPagamentoId)) return parseSituacoesPagamento('cancelado')
        }
    }

    return parseSituacoesPagamento(projeto?.status_projeto_pagamento || "");
}


export const parseFormaPagamento = (pagamentos: any, option?: string) => {
    const formasDePagamentoIds = pagamentos?.map((pagamento: any) => pagamento.forma_pagamento.id) || []
    const formasPagamentoUnico = [...new Set(formasDePagamentoIds)] 
    const pagamentosUnicos = formasPagamentoUnico?.map(formaPagamentoId => {
        return pagamentos.find((pagamento: any) => pagamento.forma_pagamento.id === formaPagamentoId)
    })

    pagamentos = pagamentosUnicos

    let formaPagamento = "";
    if (pagamentos && pagamentos.length > 0){
        if (pagamentos[0].length === 1){
            formaPagamento += `${pagamentos[0].forma_pagamento.nome}`;
            if (pagamentos[0].data_pagamento && option === "date"){
                formaPagamento += ` em ${DateUtil.dateFormat(pagamentos[0].data_pagamento,"DD/MM/YYYY")}`
            }
        }else{
            for (let i=0;i<pagamentos.length;i++){
                if (i>0){
                    formaPagamento += ` e `
                }
                formaPagamento += `${pagamentos[i].forma_pagamento.nome}`;
                if (pagamentos[i].data_pagamento && option === "date"){
                    formaPagamento += ` em ${DateUtil.dateFormat(pagamentos[i].data_pagamento,"DD/MM/YYYY")}`
                }
            }            
        }
    }
    return formaPagamento;
}

export const parseFormaPagamentoHistorico = (pagamentos: any, option?: string, formaPagamentoId?: number) => {
    const pagamentosParse = [];

    if(pagamentos.carta_credito && pagamentos.carta_credito.length){
        pagamentosParse.push({
            data_pagamento: pagamentos.carta_credito.data_pagamento,
            forma_pagamento: {
                id: FORMA_PAGAMENTO_CARTA_CREDITO,
                nome: "Financiamento Indireto"
            }
        });
    }

    if(pagamentos.boleto && pagamentos.boleto.length){
        pagamentosParse.push({
            data_pagamento: pagamentos.boleto[0].data_pagamento,
            forma_pagamento: {
                id: FORMA_PAGAMENTO_BOLETO,
                nome: "Boleto"
            }
        });
    }

    if(pagamentos.cartao_credito && pagamentos.cartao_credito.length){
        pagamentosParse.push({
            data_pagamento: pagamentos.cartao_credito[0].data_pagamento,
            forma_pagamento: {
                id: FORMA_PAGAMENTO_CARTAO_CREDITO,
                nome: "Cartão de Crédito"
            }
        });
    }

    if(pagamentos.pix && pagamentos.pix.length){
        pagamentosParse.push({
            data_pagamento: pagamentos.pix[0].data_pagamento,
            forma_pagamento: {
                id: FORMA_PAGAMENTO_PIX,
                nome: "PIX"
            }
        });
    }

    if(pagamentos.financiamento && pagamentos.financiamento.length){
        pagamentosParse.push({
            data_pagamento: pagamentos.financiamento[0].data_pagamento,
            forma_pagamento: {
                id: FORMA_PAGAMENTO_FINANCIAMENTO,
                nome: "Financiamento"
            }
        });
    }

    if (formaPagamentoId && FORMAS_PAGAMENTO_UNICO?.includes(formaPagamentoId)) {
        switch (formaPagamentoId) {
            case FORMA_PAGAMENTO_BOLETO:
                return "Boleto"
            case FORMA_PAGAMENTO_CARTAO_CREDITO:
                return "Cartão de Crédito"
            case FORMA_PAGAMENTO_FINANCIAMENTO:
                return "Financiamento"
            case FORMA_PAGAMENTO_CARTA_CREDITO:
                return "Financiamento Indireto"
            case FORMA_PAGAMENTO_PIX:
                return "PIX"
            case FORMA_PAGAMENTO_VAREJO:
                return "Varejo"
        }
    }

    return parseFormaPagamento(pagamentosParse, option);
}

export interface FilterProps {
    id_projeto?: number;
    codigo_projeto?: string;
    numero_pedido: number;
    titulo?: string;
    nome_cliente?: string;
    email_cliente?: string;
    cpf_cliente?: string;
    n_nota_fiscal?: string;
    criado_por?: string;
    revenda_id?: any;
    distribuidor_id?: any;
    etapa_venda?:{text: string; value: string; model: string; type: string;}[];
    projeto_expirado: {text: string; value: string} | null;
    projeto_kits: {text: string; value: string} | null;
    situacao: {text: string; value: string} | null;
    segmentos: {text: string; value: string} | null;
    tipo?: {text: string; value: string}[];
    origem?: {text: string; value: string} | null;
    migrado?: {text: string; value: string} | null;
    page?: number;
    pageSize?: number;
    finame?: {text: string; value: string} | null;
}

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE = 0
export const INITIAL_FILTERS_STATE:FilterProps = {
    codigo_projeto: '',
    numero_pedido: 0,
    titulo: '',
    nome_cliente: '',
    email_cliente: '',
    cpf_cliente: '',
    n_nota_fiscal: '',
    criado_por: '',
    revenda_id: null,
    distribuidor_id: null,
    etapa_venda: [],
    tipo: [],
    situacao: null,
    segmentos: null,
    origem: null,
    migrado: null,
    projeto_kits: null,
    projeto_expirado: null,
    finame: null,
}

export enum EnumMenuAcoes {
    SOLICITAR_REVISAO = 0,
    APLICAR_DESCONTO = 1,
    EDITAR_SERVICO = 2,
    REATIVAR = 3,
    CONFIRMA_VISITA_TECNICA = 4,
    ENVIAR_PAGAMENTO = 5,
    FINALIZAR = 6,
    ENVIAR_DOCUMENTO_SERVICO = 7,
    PROPOSTA_SIMPLIFICADA = 8,
    VISUALIZAR_PROPOSTA = 9,
    ENVIAR_WHATSAPP = 10,
    CLONAR_PROJETO = 11,
    VISUALIZAR_HISTORICO = 12,
    CANCELAR = 13,
    FINALIZAR_PROJETO_MANUAL = 14,
    REENVIAR_NOTA_FISCAL = 15,
    EDICAO_AVANCADA = 16,
    ATUALIZAR_ENTREGA = 17,
    ENVIAR_NOTA_FISCAL_VENDA = 18,
    CANCELAMENTO_ESPECIAL = 19,
}

const scrollToTop = ()=>{
    const el = document.getElementById(MAIN_APP_CONTAINER_ID)
    if (el) el.scrollIntoView()
}

const definirTooltipAcaoDesabilitada = (acao: MenuAcao, projeto: Projeto, permissoes: string[], pedido: Pedido) => {
    switch (acao.id) {
        case EnumMenuAcoes.EDITAR_SERVICO:
            if (!projeto?.revenda?.segmentos_servico?.includes(projeto?.segmento?.includes("on") ? "on" : "off")) acao.acaoDesabilitadaTooltip = "Revenda não habilitada para venda com valor de serviço"
            break;
        case EnumMenuAcoes.ENVIAR_WHATSAPP:
            const usuarioTemPermissao = PermissionUtil.can(PermissionUtil.PERMISSION_ENVIAR_MENSAGEM_WHATSAPP, permissoes);
            const projetoTemTelefone = !!projeto?.telefone_proposta            
            if (usuarioTemPermissao && !projetoTemTelefone) acao.acaoDesabilitadaTooltip = 'O projeto não tem telefone vinculado'
            break;
        case EnumMenuAcoes.ENVIAR_PAGAMENTO:
            if (!projeto?.data_visita_tecnica) acao.acaoDesabilitadaTooltip = "Disponível somente após a confirmação da visita técnica"
            break;
        case EnumMenuAcoes.ENVIAR_NOTA_FISCAL_VENDA:
            if (!pedido) acao.acaoDesabilitadaTooltip = "Disponível após envio para pagamento"
            break;
     }
}

function TagTriangle({ children }: { children: ReactNode }){
    return (
        <Box position={"relative"} width={"100%"} height="115px" display={"flex"} alignItems="flex-end" justifyContent="flex-end" >
            <Box style={{ width: '0', borderBottom: '115px solid red', borderLeft: '115px solid transparent' }} />
            <Box position={"absolute"} width={"115px"} height={115} style={{ backgroundColor: "transparent", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {children}
            </Box>
        </Box>
    )
}

const projetosProvider = new ProjetosProvider();

const Cards = () => {
    const projetosOffGridStoreActions = useProjetosOffGridStore(store => store.actions)

    const [tipoPropostaModalIsOpened, setTipoPropostaModalIsOpened] = useState(false)
    const [projetosEstate, setProjetos] = useState<any>();
    const [filterState, setFilterState] = useState<FilterProps>(INITIAL_FILTERS_STATE);
    const [filterBarIsOpened, setFilterBarIsOpened] = useState(false)
    const [projetoId, setProjetoId] = useState<number>();
    const [idProjetoNota, setIdProjetoNota] = useState<number>(0);
    const [openModalDetalhes, setOpenModalDetalhes] = useState(false);
    const [openEnviarNota, setOpenEnviarNota] = useState(false);
    const permissoes:string[] = useObservable(LoginStore.permissoes) || [];
    const [cleanFilter, setCleanFilter] = useState(false);
    const uploadUrl = LocalStorage.get("solar.uploadInfo", true);
    const authUser = useObservable(LoginStore.userInfoSubject())
    const mensagemWhatsAppProposta: string | undefined = useObservable(mensagemWhatsAppProposta$)
    const [openLoader, setOpenLoader] = useState(false);
    const [revendaComServicoDesabilitadoWarningModal, setRevendaComServicoDesabilitadoWarningModal] = useState<{ status: boolean; idProjeto: number | null, onConfirm: () => void }>({ status: false, onConfirm: () => {}, idProjeto: null })

    const history = useHistory();
    const { filters, setFilters } = useFilters();
    const [mounted, setMounted] = useState(false);
    
    const [filterMobileOpened, setFilterMobileOpened] = useState<boolean>(false);
    const [cardMobileOpened, setCardMobileOpened] = useState<number | null>(null);
    const [copied, setCopied] = useState<string | boolean>(false);

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const openModalRevendaComServicoDesabilitado = useCallback((idProjeto: number, onConfirm: () => void) => {
        setRevendaComServicoDesabilitadoWarningModal({
            status: true,
            idProjeto,
            onConfirm,
        })
    }, [])

    const closeModalRevendaComServicoDesabilitado = useCallback(() => {
        setRevendaComServicoDesabilitadoWarningModal({
            status: false,
            idProjeto: null,
            onConfirm: () => {},
        })
    }, [])

    useEffect(() => {
        setFilterState(filters?.projetos);
        setMounted(true);
    }, []);

    useEffect(() => {
        if (mounted) handleSearch();
    }, [mounted]);

    const handleFilterChange = (newFilter: Partial<FilterProps>) => {
        if (mounted) {
            setFilterState({ ...filterState, ...newFilter });
            if (setFilters) setFilters({...filters, projetos: { ...filterState, ...newFilter }});
        }
    };

    const checkEditedByIntelbras = (projeto: any) => {
        if (projeto?.editado_admin || projeto?.bloqueio_edicao) {
            return true;
        }
        return false;
    }
    const handleDetailDetalhes = async (projetoId: number): Promise<void> => {
        setProjetoId(projetoId);
        getCategoriasComponentes();
        setOpenModalDetalhes(true);
    }
    //abre ou fecha o modal de mppt
    const handleOpenModalDetalhes = (openModal:boolean) => {
        setOpenModalDetalhes(openModal);
        if (!openModal) {
            setProjetoId(0);
        }
    }
    //abre ou fecha o modal de alterar serviço
    const handleOpenModalAlterarServico = (openModal:boolean) => {  
        setOpenModalAlterarServico(openModal);
        if (!openModal) {
            setProjetoId(0);
        }
    }

    const handleOpenModalFinalizar = (openModal:boolean) => {
        setOpenModalFinalizar(openModal);
    }

    const handleOpenModalVisualizarProposta = (openModal:boolean) => {
        setOpenModalVisualizarProposta(openModal);
    }

    const handleOpenModalReativarProposta = (openModal:boolean, redirecionar:boolean, url:string) => {
        setOpenModalReativarProposta(openModal);
        if (redirecionar) {
            redirecionarEdicao(projetoIdAcoes, url);
        }
    }

    const handleOpenModalCancelarProjeto = (openModal:boolean) => {
        setOpenModalCancelarProjeto(openModal);
    }

    const handleGetProjetos = useCallback((params: FilterProps)=>{
        if (!params?.id_projeto) setOpenLoader(true);
        const { 
            page = DEFAULT_PAGE, 
            pageSize = DEFAULT_PAGE_SIZE, 
            titulo = '', 
            codigo_projeto = '', 
            numero_pedido = 0, 
            nome_cliente = '', 
            cpf_cliente = '',
            email_cliente = '',
            n_nota_fiscal = '',
            criado_por = '',
            revenda_id = undefined,
            distribuidor_id = undefined,
            etapa_venda = [],
            tipo = [],
            situacao = null,
            projeto_expirado = null,
            projeto_kits = null,
            segmentos = null,
            origem = null,
            migrado = null,
            finame = null,
            id_projeto = null
        } = params;
        adminStore.getProjetos(page + 1, pageSize, titulo, codigo_projeto, id_projeto, numero_pedido,  nome_cliente,  cpf_cliente, email_cliente, n_nota_fiscal, criado_por, revenda_id, distribuidor_id, etapa_venda, projeto_expirado, projeto_kits, situacao, segmentos, origem, migrado, finame, tipo, true).then((result) => {
            if (id_projeto && result?.length) {
                const projetoAtualizado = result[0];
                setProjetos((prev: any) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        rows: prev?.rows?.map((item:any) => item.id === projetoAtualizado.id ? { ...item, ...projetoAtualizado } : item) || []
                    };
                });
            } else {
                setProjetos(result)
            }

            if (!params?.id_projeto) {
                setOpenLoader(false);
                scrollToTop();
            }
        });
    }, [projetosEstate]);

    /*
    useEffect(() => {
        handleGetProjetos({} as FilterProps)
    }, [handleGetProjetos]);
    */

   useEffect(() => {
       const acoes: MenuAcao[] = [];
        acoes.push({id: EnumMenuAcoes.SOLICITAR_REVISAO, handleOpenAcao: handleOpenAcao, titulo: 'Solicitar Revisão'})
        acoes.push({id: EnumMenuAcoes.APLICAR_DESCONTO, handleOpenAcao: handleOpenAcao, titulo: 'Aplicar Desconto'})
        acoes.push({id: EnumMenuAcoes.EDITAR_SERVICO, handleOpenAcao: handleOpenAcao, titulo: 'Editar Serviço'})
        acoes.push({id: EnumMenuAcoes.REATIVAR, handleOpenAcao: handleOpenAcao, titulo: 'Reativar'})
        acoes.push({id: EnumMenuAcoes.CONFIRMA_VISITA_TECNICA, handleOpenAcao: handleOpenAcao, titulo: 'Confirmar Visita Técnica'})
        acoes.push({id: EnumMenuAcoes.ENVIAR_PAGAMENTO, handleOpenAcao: handleOpenAcao, titulo: 'Enviar para Pagamento'})
        acoes.push({id: EnumMenuAcoes.FINALIZAR, handleOpenAcao: handleOpenAcao, titulo: 'Finalizar'})
        acoes.push({id: EnumMenuAcoes.ENVIAR_DOCUMENTO_SERVICO, handleOpenAcao: handleOpenAcao, titulo: 'Documento Serviço'})
        acoes.push({id: EnumMenuAcoes.PROPOSTA_SIMPLIFICADA, handleOpenAcao: handleOpenAcao, titulo: 'Proposta Simplificada'})
        acoes.push({id: EnumMenuAcoes.VISUALIZAR_PROPOSTA, handleOpenAcao: handleOpenAcao, titulo: 'Proposta Detalhada'})
        acoes.push({id: EnumMenuAcoes.ENVIAR_WHATSAPP, handleOpenAcao: handleOpenAcao, titulo: 'Enviar WhatsApp'})
        acoes.push({id: EnumMenuAcoes.CLONAR_PROJETO, handleOpenAcao: handleOpenAcao, titulo: 'Clonar Projeto'})
        acoes.push({id: EnumMenuAcoes.VISUALIZAR_HISTORICO, handleOpenAcao: handleOpenAcao, titulo: 'Visualizar Histórico'})
        acoes.push({id: EnumMenuAcoes.CANCELAR, handleOpenAcao: handleOpenAcao, titulo: 'Cancelar Projeto'})
        acoes.push({id: EnumMenuAcoes.FINALIZAR_PROJETO_MANUAL, handleOpenAcao: handleOpenAcao, titulo: 'Finalização Manual'})
        acoes.push({id: EnumMenuAcoes.REENVIAR_NOTA_FISCAL, handleOpenAcao: handleOpenAcao, titulo: 'Reenviar Nota Fiscal'})
        acoes.push({id: EnumMenuAcoes.EDICAO_AVANCADA, handleOpenAcao: handleOpenAcao, titulo: 'Edição Avançada'})
        acoes.push({id: EnumMenuAcoes.ATUALIZAR_ENTREGA, handleOpenAcao: handleOpenAcao, titulo: 'Atualizar Entrega'})
        acoes.push({id: EnumMenuAcoes.ENVIAR_NOTA_FISCAL_VENDA, handleOpenAcao: handleOpenAcao, titulo: 'Enviar Nota Fiscal de Venda'})
        acoes.push({id: EnumMenuAcoes.CANCELAMENTO_ESPECIAL, handleOpenAcao: handleOpenAcao, titulo: 'Cancelamento Especial'})
        setAcoes(acoes);
    }, []);

    useEffect(() => {
        initLoad().then(() => {
            initEstadosServicos()
        })
    }, []);
    
    const initLoad = async () => {
        await Promise.all([
            getEstadosServicoRegioes(),
            getUpload(),
        ])
    };

    const initEstadosServicos = useCallback(()=>{
        const estadosPermissaoServico:string[] = [];
        estadosServicoRegioes$?.forEach((estadosServicos) => {
            estadosServicos.data.forEach((estadoServico:any) => {
                estadoServico?.regioes?.estados.forEach((estado:any) => {
                    if (estadosPermissaoServico.filter(e => e === estado.estado_id).length === 0) {
                        estadosPermissaoServico.push(estado.estado_id);
                    }
                });
            });
        })
        setEstadosPermitemServicos(estadosPermissaoServico);
    },[]);

    const handleChangePageSize = useCallback((event) => {
        const pSize = parseInt(event.target.value, 10)
        handleFilterChange({...filterState, page: 0, pageSize: pSize});
        handleGetProjetos({...filterState, page: 0, pageSize: pSize})
    },[filterState, handleGetProjetos])

    const handleChangePage = useCallback((event, newPage) => {
        handleFilterChange({...filterState, page: newPage});
        handleGetProjetos({...filterState, page: newPage})

    },[filterState, handleGetProjetos])

    const handleCleanFilter = () => {
        handleFilterChange(INITIAL_FILTERS_STATE);
        setCleanFilter(true);
    }
    const handleSearch = useCallback(()=>{
        if (mounted) {
            handleFilterChange({...filterState, page: 0});
            handleGetProjetos({...filterState, page: 0})
            setFilterBarIsOpened(false)
        }
    },[filterState, handleGetProjetos, mounted])

    //estados serviços
    const [estadosPermitemServicos, setEstadosPermitemServicos] = useState<string[]>([]);
    //popup ações
    const [listaAcoes, setAcoes] = useState<MenuAcao[]>([]);
    const [anchorAcao, setanchorAcao] = React.useState<HTMLButtonElement | null>(null);
    const [projetoIdAcoes, setProjetoIdAcoes] = React.useState<number>(0);
    const [openModalAlterarServico, setOpenModalAlterarServico] = React.useState<boolean>(false);
    const [openModalCancelarProjeto, setOpenModalCancelarProjeto] = React.useState<boolean>(false);
    const [openModalFinalizar, setOpenModalFinalizar] = React.useState<boolean>(false);
    const [openModalVisualizarProposta, setOpenModalVisualizarProposta] = React.useState<boolean>(false);
    const [openModalReativarProposta, setOpenModalReativarProposta] = React.useState<boolean>(false);
    const [tipoVisualizacaoProposta, setTipoVisualizacaoProposta] = React.useState<TiposVisualizacaoProposta>();
    const openPopoverAcao = Boolean(anchorAcao);
    const [openConfirmaVisita, setOpenConfirmaVisita] = useState<boolean>(false);
    const [openFinalizarProjetoRenovigiProjetoIdModal, setOpenFinalizarProjetoRenovigiProjetoIdModal] = useState(0);
    const [idProjetoVisita, setIdProjetoVisita] = useState<number>(0);
    const [openModalDesconto, setOpenModalDesconto] = React.useState<boolean>(false);
    const [openModalEnviarDocumentosServico, setOpenModalEnviarDocumentosServico] = React.useState<boolean>(false);
    const [openModalCancelamentoEspecial, setOpenModalCancelamentoEspecial] = useState(false)
    const [openModalClonarProjeto, setOpenModalClonarProjeto] = useState(false)
    const [openModalReenviarNotaFiscal, setOpenModalReenviarNotaFiscal] = useState(false)
    const [openModalAtualizarEntrega, setOpenModalAtualizarEntrega] = useState(false)

    const [openEnviarPagamento, setOpenEnviarPagamento] = useState<boolean>(false);
    const [idProjetoPagamento, setIdProjetoPagamento] = useState<number>(0);
    const [reativarProjeto, setReativarProjeto] = useState<boolean>(false);

    const projetosListagem = useMemo(() => {
        return projetosEstate?.rows || [];
    }, [projetosEstate?.rows]);

    const currentProjeto = useMemo(() => {
        return projetosListagem?.find((p:Projeto) => p.id === projetoIdAcoes);
    }, [projetosListagem, projetoIdAcoes]);

    const handleShowProposta = (projeto: Projeto, permissions: string[]) => {
        if (!projeto) return;

        let tipoProposta: TiposVisualizacaoProposta | '' = TiposVisualizacaoProposta.SIMPLIFICADA
        const temTodasPermissoes = PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissions) && PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissions)
        
        const origemUploads = projeto?.uploads?.find(i => i?.origem === 'V1');

        if (projeto?.segmento === 'distribuicao_offgrid') {
            tipoProposta = TiposVisualizacaoProposta.SIMPLIFICADA
        } else if (projeto?.origem === 'V1' && projeto?.uploads?.length === 1 && origemUploads) {
            tipoProposta = origemUploads?.tipo?.includes('simplificada') ? TiposVisualizacaoProposta.SIMPLIFICADA : TiposVisualizacaoProposta.DETALHADA;
        } else if (projeto?.tipo !== "dimensionado") {
            switch (projeto?.tipo) {
                case "vertical":
                    tipoProposta = buscaTipoDePropostaDeAcordoComPermissao(permissions)
                    break;
                case "personalizado":
                    if (projeto.tipo_faturamento !== 'cliente') {
                        tipoProposta = TiposVisualizacaoProposta.SIMPLIFICADA
                        break;
                    }

                    if (temTodasPermissoes) {
                        setTipoPropostaModalIsOpened(true)
                        tipoProposta = ''
                    } else {
                        tipoProposta = buscaTipoDePropostaDeAcordoComPermissao(permissions)
                    }

                    break;
                case "kit":
                    const kits = projeto?.carrinho && projeto.carrinho.length ? projeto.carrinho[0] : null
                    const kit = kits && Array.isArray(kits) ? kits[0] : kits;
                    const escolheuDetalhada = projeto?.tipo_proposta_envio === 'detalhada'

                    if (kit?.itens?.length === 1 && kit?.itens[0]?.quantidade === 1 && escolheuDetalhada) {
                        if (temTodasPermissoes) {
                            setTipoPropostaModalIsOpened(true)
                            tipoProposta = ''
                        } else {
                            tipoProposta = buscaTipoDePropostaDeAcordoComPermissao(permissions)
                        }
                    } else {
                        tipoProposta = TiposVisualizacaoProposta.SIMPLIFICADA 
                    }
                    break;
            }
        } else {
            if (temTodasPermissoes) {
                setTipoPropostaModalIsOpened(true)
                tipoProposta = ''
            } else {
                tipoProposta = buscaTipoDePropostaDeAcordoComPermissao(permissions)
            }
        }

        return tipoProposta || ''
    };

    const handleClickPopoverAcao = async (event: React.MouseEvent<HTMLButtonElement>, projetoId: number): Promise<void> => {
        // adminStore.buscarProjeto(projetoId, true);
        handleGetProjetos({...filterState, id_projeto: projetoId});
        setProjetoIdAcoes(projetoId)
        setanchorAcao(event.currentTarget);
    }
    //implementar cada ação
    const handleOpenAcao = async (menuAcao: MenuAcao, wppMessage: string, permissions: string[]) => {
        handleClosePopover();

        const projetoPossuiServico = menuAcao?.projeto?.valor_servico && Number(menuAcao?.projeto?.valor_servico) > 0;
        const revendaPermiteServico = menuAcao?.projeto?.revenda?.segmentos_servico?.includes(menuAcao?.projeto?.segmento?.includes("on") ? "on" : "off") || false;
        const segmentoProjeto = menuAcao?.projeto?.segmento?.includes('off') ? 'off' : 'on';
        const revendaId = menuAcao?.projeto?.revenda_id || menuAcao?.projeto?.revenda?.id || undefined;
        const distribuidorId = menuAcao?.projeto?.distribuidor_id || menuAcao?.projeto?.distribuidor?.id || undefined;
        let validarSegmentoConta;

        switch (menuAcao.id) {
            case EnumMenuAcoes.FINALIZAR_PROJETO_MANUAL:
                setOpenFinalizarProjetoRenovigiProjetoIdModal(menuAcao.projetoId || 0)
                break;
            case EnumMenuAcoes.CONFIRMA_VISITA_TECNICA:
                if (!menuAcao.projetoId) return; 

                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;

                setIdProjetoVisita(menuAcao.projetoId);

                if (!projetoPossuiServico || revendaPermiteServico) {
                    setOpenConfirmaVisita(true);
                    break;
                }

                openModalRevendaComServicoDesabilitado(menuAcao.projetoId, () => {
                    closeModalRevendaComServicoDesabilitado();
                    setOpenConfirmaVisita(true);
                })

                break;
            case EnumMenuAcoes.REATIVAR:
                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;
                checarReativarProjeto(menuAcao?.projeto);
                break;
            case EnumMenuAcoes.FINALIZAR:
                setOpenModalFinalizar(true)
                break;
            case EnumMenuAcoes.VISUALIZAR_PROPOSTA:
                setTipoVisualizacaoProposta(TiposVisualizacaoProposta.DETALHADA)
                setOpenModalVisualizarProposta(true);
                break;
            case EnumMenuAcoes.APLICAR_DESCONTO:
                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;
                setOpenModalDesconto(true);
                break;
            case EnumMenuAcoes.ENVIAR_DOCUMENTO_SERVICO:
                setOpenModalEnviarDocumentosServico(true);
                break;
            case EnumMenuAcoes.ENVIAR_NOTA_FISCAL_VENDA:
                setIdProjetoNota(menuAcao.projetoId || 0);
                setOpenEnviarNota(true);
                break;
            case EnumMenuAcoes.VISUALIZAR_HISTORICO:
                history.push(`/projetos/listagem/historico/${menuAcao?.codigoVenda}`);
                break;
            case EnumMenuAcoes.PROPOSTA_SIMPLIFICADA:
                setTipoVisualizacaoProposta(TiposVisualizacaoProposta.SIMPLIFICADA)
                setOpenModalVisualizarProposta(true)    
                break;
            case EnumMenuAcoes.EDITAR_SERVICO:
                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;
                setOpenModalAlterarServico(true);
                break;  
            case EnumMenuAcoes.SOLICITAR_REVISAO:
                redirecionarSolicitarRevisao(menuAcao?.codigoVenda ? menuAcao.codigoVenda : '');
                break;
            case EnumMenuAcoes.CANCELAR:
                setOpenModalCancelarProjeto(true);
                break;
            case EnumMenuAcoes.ENVIAR_PAGAMENTO:
                if (!menuAcao.projetoId) return;

                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;

                setIdProjetoPagamento(menuAcao.projetoId);

                if (!projetoPossuiServico || revendaPermiteServico) {
                    setOpenEnviarPagamento(true);
                    break;
                }

                openModalRevendaComServicoDesabilitado(menuAcao.projetoId, () => {
                    closeModalRevendaComServicoDesabilitado();
                    setOpenEnviarPagamento(true);
                })

                break;    
            case EnumMenuAcoes.EDICAO_AVANCADA:
                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;
                history.push(`/projetos/edicao_avancada/${menuAcao?.codigoVenda}`);
                break;                                                                                                                                          
            case EnumMenuAcoes.CANCELAMENTO_ESPECIAL:
                setOpenModalCancelamentoEspecial(true)
                break;                                                                                                                                    
            case EnumMenuAcoes.CLONAR_PROJETO:
                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;
                checarClonarProjeto(menuAcao?.projeto)
                break;                                                                                                                                    
            case EnumMenuAcoes.REENVIAR_NOTA_FISCAL:
                setOpenModalReenviarNotaFiscal(true)
                break;                                                                                                                                       
            case EnumMenuAcoes.ENVIAR_WHATSAPP:
                if (!menuAcao?.projeto?.telefone_proposta) return;
                if (!menuAcao?.projeto?.codigo_venda) return;
                const telefone = (menuAcao?.projeto?.telefone_proposta || '').toString().replace(/\D/g, '');
                const tipoProposta = menuAcao?.projeto?.tipo_proposta_envio || '';
                let url = ''

                const temPermissaoDeProposta = PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissions) || PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissions)
                let wppMessageLocal = temPermissaoDeProposta ? (wppMessage || '') : ''

                if (menuAcao?.projeto?.segmento?.includes("vertical")) {
                    wppMessageLocal = ''
                }

                if (!tipoProposta || tipoProposta === 'link') {
                    const novoTipoProposta = handleShowProposta(menuAcao?.projeto, permissions)
                    if (!novoTipoProposta) return;
                    const telefone = (menuAcao?.projeto?.telefone_proposta || '').toString().replace(/\D/g, '');
                    url = WhatsAppUtil.montarUrlProposta(novoTipoProposta as string, menuAcao?.projeto?.codigo_venda || '', telefone, wppMessageLocal)
                } else {
                    url = WhatsAppUtil.montarUrlProposta(tipoProposta, menuAcao?.projeto?.codigo_venda || '', telefone, wppMessageLocal)
                }

                if (url) {
                    window.open(url, "_blank", "noopener,noreferrer");
                    await projetosProvider.registrarEnvioPropostaWhatsapp(menuAcao?.projeto?.id || 0, 'menu-acoes')
                }

                break;
            case EnumMenuAcoes.ATUALIZAR_ENTREGA:
                setOpenModalAtualizarEntrega(true)
                break;
            default:
                break;
        }
    };
    const handleClosePopover = () => {
        setanchorAcao(null);
    };

    const checarClonarProjeto = (projeto?: Projeto) => {
        if (!projeto) return;

        const uf = projeto?.estado_id || "";
        const itens: ComponenteClonagem[] = [];
        const componentes: ComponentePrevisao[] = [];

        let tipoProjeto = projeto?.tipo || '';
        const isOffGrid = projeto?.segmento?.includes("offgrid")
        const hibrido = projeto?.codigo_venda?.includes("HIBRI")
        const isPersonalizadoHibrido = projeto?.codigo_venda?.includes("HIBRI") && tipoProjeto === "personalizado"
        const urlsFromTipoClonar: {[index: string]: string} = {
            dimensionado: `/projetos/${projeto.id}/offgrid/clonar`,
            personalizado: `/projetos/${projeto.id}/personalizado_offgrid/clonar`,
            personalizado_hibrido: `/projetos/${projeto.id}/personalizado_hibrido/clonar`,
            dimensionado_hibrido: `/projetos/${projeto.id}/dimensionado_hibrido/clonar`
        }

        if(hibrido) {
            tipoProjeto = tipoProjeto + "_hibrido"
        }

        projeto?.componentes?.forEach((componente: any) => {
            componentes.push({
                codigo: componente.componente_id,
                quantidade: componente.quantidade,
            });
            itens.push({ id: componente.componente_id });
        });

        // Validar Clonagem
        const payload: RequestClonagem = {
            estado_id: uf,
            valor: projeto?.valor,
            valor_servico: projeto?.valor_servico,
            valor_servico_pis_cofins: projeto?.valor_servico_pis_cofins,
            servico: projeto?.servico || "",
            componentes: itens,
            potencia: projeto?.potencia || 0,
            projeto_original_id: projeto?.id || 0,
            segmento: projeto?.segmento || "",
        };
        const requestApi: IDataRequest = {
            url: "/projetos/clonagem/verificar",
            data: payload
        }

        api.post(requestApi).then(response => {
            const messages = Array.isArray(response.message) ? response.message : []
            const valido = messages.length === 0
            const erroPermissao = messages.find(msg => msg.includes("Usuário sem permissão"));

            if (valido) {
                setOpenModalClonarProjeto(true)
                return
            }

            if (!!erroPermissao) {
                notifierStore.setNotifier({
                    title: "Atenção!",
                    content: [erroPermissao],
                    onClose: () => {
                        notifierStore.setOpen(false);
                        return;
                    },
                    timeOut: 4000,
                    onFinishTimeout: () => {
                        notifierStore.setOpen(false);
                    }
                })
                notifierStore.setOpen(true);
                return;
            }

            notifierStore.setNotifier({
                title: "Atenção!",
                content: [
                    'Alguns itens do projeto original não estão mais disponíveis.',
                    'Você será direcionado para a edição do projeto para revisar e ajustar a solução conforme as configurações atuais.'
                ],
                onClose: () => {
                    notifierStore.setOpen(false);
                    history.replace(isOffGrid || hibrido ? urlsFromTipoClonar[tipoProjeto] : (isPersonalizadoHibrido ? urlsFromTipoClonar["personalizado_hibrido"] :`/projetos/${projeto.id}/clonar`))
                    return;
                },
                timeOut: 4000,
                onFinishTimeout: () => {
                    notifierStore.setOpen(false);
                    history.replace(isOffGrid || hibrido ? urlsFromTipoClonar[tipoProjeto] : (isPersonalizadoHibrido ? urlsFromTipoClonar["personalizado_hibrido"] :`/projetos/${projeto.id}/clonar`))
                }
            })
            notifierStore.setOpen(true);
        })
    }

    const handleSugestao = async(acao: AcoesSugeridas, projeto: Projeto) => {
        const projetoPossuiServico = projeto?.valor_servico && Number(projeto?.valor_servico) > 0;
        const revendaPermiteServico = projeto?.revenda?.segmentos_servico?.includes(projeto?.segmento?.includes("on") ? "on" : "off") || false;
        const segmentoProjeto = projeto?.segmento?.includes('off') ? 'off' : 'on';
        const revendaId = projeto?.revenda_id || projeto?.revenda?.id || undefined;
        const distribuidorId = projeto?.distribuidor_id || projeto?.distribuidor?.id || undefined;
        const projetoId = Number(projeto?.id);
        let validarSegmentoConta = null;
        switch (acao){
            case AcoesSugeridas.CONFIRMAR_VISITA_TECNICA:
                if (!projetoId) return; 

                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;

                setIdProjetoVisita(projetoId);

                if (!projetoPossuiServico || revendaPermiteServico) {
                    setOpenConfirmaVisita(true);
                    break;
                }

                openModalRevendaComServicoDesabilitado(projetoId, () => {
                    closeModalRevendaComServicoDesabilitado();
                    setOpenConfirmaVisita(true);
                })
                break;
            case AcoesSugeridas.FINALIZAR:
                setOpenModalFinalizar(true)
                break;
            case AcoesSugeridas.ENVIAR_PAGAMENTO:
                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;

                setIdProjetoPagamento(projetoId);

                if (!projetoPossuiServico || revendaPermiteServico) {
                    setOpenEnviarPagamento(true);
                    break;
                }

                openModalRevendaComServicoDesabilitado(projetoId, () => {
                    closeModalRevendaComServicoDesabilitado();
                    setOpenEnviarPagamento(true);
                })

                break;
            case AcoesSugeridas.REATIVAR:
                validarSegmentoConta = await verificarSegmentoConta({ segmento: segmentoProjeto, revendaId, distribuidorId });
                if (!validarSegmentoConta) return;
                checarReativarProjeto(projeto);
                break;
            case AcoesSugeridas.ENVIAR_DOCUMENTO_SERVICO:
                setOpenModalEnviarDocumentosServico(true);
                break;
        }
    }

    const checarReativarProjeto = (projeto?: Projeto) => {
        if (!projeto) return;

        const uf = projeto?.estado_id || "";
        const itens: ComponenteClonagem[] = [];

        projeto?.componentes?.forEach((componente: any) => {
            itens.push({ id: componente.componente_id });
        });

        // Validar Clonagem
        const payload: RequestClonagem = {
            estado_id: uf,
            valor: projeto?.valor,
            valor_servico: projeto?.valor_servico,
            valor_servico_pis_cofins: projeto?.valor_servico_pis_cofins,
            servico: projeto?.servico || "",
            componentes: itens,
            potencia: projeto?.potencia || 0,
            projeto_original_id: projeto?.id || 0,
            reativar_projeto: true,
            segmento: projeto?.segmento || "",
        };
        const requestApi: IDataRequest = {
            url: "/projetos/clonagem/verificar",
            data: payload
        }

        apiNoMessageError.post(requestApi).then(response => {

            const valido = response.statusCode === STATUS_CODE.OK;

            setReativarProjeto(valido);
            setOpenModalReativarProposta(true)
        })
    }

    const getAcoes = (): React.ReactNode[] => {
        const acoes: React.ReactNode[] = [];
        if (currentProjeto) {
            const pedido = currentProjeto?.pedidos[0];
            listaAcoes.forEach((acao: MenuAcao) => {
                acao.projetoId = projetoIdAcoes;
                checarStatusAcao(acao, currentProjeto, pedido, permissoes, estadosPermitemServicos, authUser);
                definirTooltipAcaoDesabilitada(acao, currentProjeto, permissoes, pedido)
                let menuItem: React.ReactNode = (acao.id === EnumMenuAcoes.ENVIAR_NOTA_FISCAL_VENDA && acao.exibicao === TipoExibicao.DESATIVO ?
                    <ItemMenuEnviarNota 
                        id={acao.id}
                        titulo={acao.titulo}
                        projetoId={acao.projetoId}
                        handleOpenAcao={(menuAcao: any) => typeof acao.handleOpenAcao === 'function' && acao.handleOpenAcao(menuAcao, mensagemWhatsAppProposta, permissoes)}
                        codigoVenda={currentProjeto?.codigo_venda}
                        exibicao={acao.exibicao}
                        status_projeto={currentProjeto.status_projeto}
                    />
                    : 
                    <MenuItemAcao 
                        id={acao.id}
                        titulo={acao.titulo}
                        projetoId={acao.projetoId}
                        handleOpenAcao={(menuAcao: any) => typeof acao.handleOpenAcao === 'function' && acao.handleOpenAcao(menuAcao, mensagemWhatsAppProposta, permissoes)}
                        codigoVenda={currentProjeto?.codigo_venda}
                        exibicao={acao.exibicao}
                        status_projeto={currentProjeto.status_projeto}
                        projeto={currentProjeto}
                        acaoDesabilitadaTooltip={acao.acaoDesabilitadaTooltip}
                    ></MenuItemAcao>)

                acoes.push(menuItem);
            });
        }
        return acoes;
    }

    const validadeProposta = (projeto: any, pedido: any) => {
        if (!['pre_orcamento', 'proposta_final'].includes(projeto?.status_projeto)) return null
        if (['cancelado'].includes(projeto?.situacao)) return null

        const diffDaysExpiracaoProjeto = projeto?.data_expiracao ? differenceInCalendarDays(new Date(projeto?.data_expiracao), new Date()) : 0
        const diffDaysExpiracaoPedidoPagamento = pedido?.data_expiracao_pagamento ? differenceInCalendarDays(new Date(pedido?.data_expiracao_pagamento), new Date()) : 0
        const diffDaysExpiracaoPedido = pedido?.data_expiracao ? differenceInCalendarDays(new Date(pedido?.data_expiracao), new Date()) : 0

        const projetoExpirado = projeto?.situacao === 'expirado'
        const pedidoCancelado = pedido?.situacao === 'cancelado'

        if (projeto && !pedido?.data_expiracao_pagamento && (!pedido || pedidoCancelado || ["pre_orcamento", "negociacao", "analise_financiamento"].includes(projeto?.etapa_venda))) {
            if (projetoExpirado) {
                return (
                    <TagTriangle>
                        <span style={{ transform: 'rotate(-45deg)', color: '#ffffff', position: 'relative', top: '10%', left: '10%' }}>Expirado</span>
                    </TagTriangle>
                )
            }

            if (projeto?.data_expiracao && projeto?.tipo !== 'kit') {
                if (diffDaysExpiracaoProjeto === 0) {
                    return (
                        <TagTriangle>
                            <span style={{ transform: 'rotate(-45deg)', color: '#ffffff', position: 'relative', top: '10%', left: '10%' }}>Expira hoje</span>
                        </TagTriangle>
                    )
                }
    
                if (diffDaysExpiracaoProjeto > 0) {
                    return (
                        <TagTriangle>
                            <span style={{ transform: 'rotate(-45deg)', color: '#ffffff', position: 'relative', top: '15%', left: '15%' }}>Expira em <br/> {diffDaysExpiracaoProjeto} {diffDaysExpiracaoProjeto > 1 ? "dias" : "dia"}</span>
                        </TagTriangle>
                    )
                }
            }
        }

        if (pedido && !pedido.forma_pagamento && pedido?.data_expiracao) {
            if (diffDaysExpiracaoPedido === 0) {
                return (
                    <TagTriangle>
                        <span style={{ transform: 'rotate(-45deg)', color: '#ffffff', position: 'relative', top: '15%', left: '15%' }}>Cancela hoje</span>
                    </TagTriangle>
                )
            }

            if (diffDaysExpiracaoPedido > 0) {
                return (
                    <TagTriangle>
                        <span style={{ transform: 'rotate(-45deg)', color: '#ffffff', position: 'relative', top: '15%', left: '15%' }}>Cancela em <br/> {diffDaysExpiracaoPedido} {diffDaysExpiracaoPedido > 1 ? "dias" : "dia"}</span>
                    </TagTriangle>
                )
            }
        }

        if(pedido?.forma_pagamento && pedido?.data_expiracao_pagamento) {
            if (diffDaysExpiracaoPedidoPagamento === 0) {
                return (
                    <TagTriangle>
                        <span style={{ transform: 'rotate(-45deg)', color: '#ffffff', position: 'relative', top: '15%', left: '15%' }}>Pagamento <br/>até hoje</span>
                    </TagTriangle>
                )
            }

            if (diffDaysExpiracaoPedidoPagamento > 0) {
                return (
                    <TagTriangle>
                        <span style={{ transform: 'rotate(-45deg)', color: '#ffffff', position: 'relative', top: '15%', left: '15%' }}>Pagamento em <br/>até {diffDaysExpiracaoPedidoPagamento} {diffDaysExpiracaoPedidoPagamento > 1 ? "dias" : "dia"}</span>
                    </TagTriangle>
                )
            }
        }
    }
    const validadePropostaMobile = (projeto: any, pedido: any) => {
        if (!['pre_orcamento', 'proposta_final'].includes(projeto?.status_projeto)) return null
        if (['cancelado'].includes(projeto?.situacao)) return null

        const diffDaysExpiracaoProjeto = projeto?.data_expiracao ? differenceInCalendarDays(new Date(projeto?.data_expiracao), new Date()) : 0
        const diffDaysExpiracaoPedidoPagamento = pedido?.data_expiracao_pagamento ? differenceInCalendarDays(new Date(pedido?.data_expiracao_pagamento), new Date()) : 0
        const diffDaysExpiracaoPedido = pedido?.data_expiracao ? differenceInCalendarDays(new Date(pedido?.data_expiracao), new Date()) : 0

        const projetoExpirado = projeto?.situacao === 'expirado'
        const pedidoCancelado = pedido?.situacao === 'cancelado'

        if (projeto && !pedido?.data_expiracao_pagamento && (!pedido || pedidoCancelado || ["pre_orcamento", "negociacao", "analise_financiamento"].includes(projeto?.etapa_venda))) {
            if (projetoExpirado) {
                return (
                    <Typography>
                        <span style={{ color: 'red', fontWeight: 600 }}>Expirado</span>
                    </Typography>
                )
            }

            if (projeto?.data_expiracao && projeto?.tipo !== 'kit') {
                if (diffDaysExpiracaoProjeto === 0) {
                    return (
                        <Typography>
                            <span style={{ color: 'red', fontWeight: 600 }}>Expira hoje</span>
                        </Typography>
                    )
                }
    
                if (diffDaysExpiracaoProjeto > 0) {
                    return (
                        <Typography>
                            <span style={{ color: 'red', fontWeight: 600 }}>Expira em {diffDaysExpiracaoProjeto} {diffDaysExpiracaoProjeto > 1 ? "dias" : "dia"}</span>
                        </Typography>
                    )
                }
            }
        }

        if (pedido && !pedido.forma_pagamento && pedido?.data_expiracao) {
            if (diffDaysExpiracaoPedido === 0) {
                return (
                    <Typography>
                        <span style={{ color: 'red', fontWeight: 600 }}>Cancela hoje</span>
                    </Typography>
                )
            }

            if (diffDaysExpiracaoPedido > 0) {
                return (
                    <Typography>
                        <span style={{ color: 'red', fontWeight: 600 }}>Cancela em {diffDaysExpiracaoPedido} {diffDaysExpiracaoPedido > 1 ? "dias" : "dia"}</span>
                    </Typography>
                )
            }
        }

        if(pedido?.forma_pagamento && pedido?.data_expiracao_pagamento) {
            if (diffDaysExpiracaoPedidoPagamento === 0) {
                return (
                    <Typography>
                        <span style={{ color: 'red', fontWeight: 600 }}>Pagamento até hoje</span>
                    </Typography>
                )
            }

            if (diffDaysExpiracaoPedidoPagamento > 0) {
                return (
                    <Typography>
                        <span style={{ color: 'red', fontWeight: 600 }}>Pagamento em até {diffDaysExpiracaoPedidoPagamento} {diffDaysExpiracaoPedidoPagamento > 1 ? "dias" : "dia"}</span>
                    </Typography>
                )
            }
        }
    }

    const redirecionarSolicitarRevisao = (codigoVenda: string) => {
        const projeto = { "codigo_projeto": codigoVenda };
        const encondedProjeto = encodeURIComponent(Buffer.from(JSON.stringify(projeto)).toString("base64"))
        const url = `/projetos/verticais/revisao/${encondedProjeto}`
        formState$.next(DEFAULT_PROJETO);
        history.push(url);
    }

    const redirecionarEdicao = (projetoId: number, url: string) => {
        formState$.next(DEFAULT_PROJETO);
        history.push(url);
    }

    const handleDesconto = (projeto: any, pedido: any) => {
        let text1 = "";
        let text2 = "";
        if (projeto) {
            const valor = projeto?.valor;
            const valorProjeto = (projeto?.valor_projeto - projeto?.valor_servico_pis_cofins);
            if (valor && valor > 0 && valor - valorProjeto > 0) {
                text1 += Formater.toString(((valor - valorProjeto)).toFixed(2), TypeRecords.CURRENCY);
            }
        }
        if(pedido){
            if (pedido?.cupom_desconto && pedido?.valor_desconto){
                text2 += Formater.toString((pedido.valor_desconto), TypeRecords.CURRENCY) + ` (Cupom: ${pedido.cupom_desconto})`;
            }
        }
        if (text1.length > 0){
            if (text2.length > 0){
                return(<>
                    {text1}
                    <br/>
                    {text2}
                </>)
            }else{
                return text1;
            }
        } else if (text2.length > 0){
            return text2; 
        } else {
            return "-";
        }
    }
    const handleValorTotal = (projeto: any, pedido: any) => {
        return Formater.toString((projeto?.valor - projeto?.valor_desconto + projeto?.valor_servico_pis_cofins - (pedido?.valor_desconto ? pedido.valor_desconto : 0)), TypeRecords.CURRENCY) || "-";
    }
    const handleValorProdutosComDesconto = (projeto: any, pedido: any) => {
        return Formater.toString(projeto?.valor - projeto?.valor_desconto - (pedido?.valor_desconto ? pedido.valor_desconto : 0), TypeRecords.CURRENCY) || "-";
    }
    /* Não é mais utilizado - Comentado na SOL-430
    const loadUsersIntelbras = async () => {
        const intbUsers: UsersIntelbras[] = [];
        const request: IDataRequest = {
            url: `/usuarios`
        }    
        const response: IDataResponse = await apiNoLoading.get(request);
        if (response.statusCode === STATUS_CODE.OK) {
            const dados = response.data;
            for (let i = 0; i < dados.length; i++) {
                if (/@intelbras.com.br\s*$/.test(dados[i].usuario)) {
                    const userNew: UsersIntelbras = {
                        id:dados[i].id
                    };
                    intbUsers.push(userNew);
                }
            }
        }   
        setUsersIntelbras(intbUsers);
    }
    */
    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    /* Não é mais utilizado - Comentado na SOL-430
    useEffect(()=>{
        loadUsersIntelbras();
    },[])
    */

    useEffect(()=>{
        if (mounted && cleanFilter) handleSearch();
        setCleanFilter(false)
    },[cleanFilter, mounted])

    const maskDate = useCallback((date: string)=>{
        if (date && date.length > 0){
            const _aDate = date.split(" ");
            const aDate = _aDate[0].split("-");
            return(aDate[2] + "/" + aDate[1] + "/" + aDate[0])
        } else {
            return "-";
        }
    },[projetosEstate])

    const parsePrevisaoFaturamento = (data_previsao: any, data_pagamento: any, pagamentos: any[]) => {
        if (!data_previsao || maskDate(data_previsao)?.includes('01/01/0001')) {
            if (pagamentos?.length) {
                const index = pagamentos?.length - 1;
                const dataFaturamentoV1 = pagamentos[index]?.dados_migracao?.DataFaturamentoPagamento;
                if (dataFaturamentoV1) {
                    const date = dataFaturamentoV1?.replace("T", '-')?.split('-');
                    const customDate = date?.length > 2 && `${date[2] + "/" + date[1] + "/" + date[0]}`;
                    if (customDate && !customDate?.includes('01/01/0001')) return `A partir de ${customDate}`;
                }
            }
            return "-";
        }else if (!data_pagamento){
            return `A partir de ${maskDate(data_previsao)}`
        }else{
            return maskDate(data_previsao)
        }
    }

    const onClickEdit = useCallback(async (projeto: any)=> {
        const validarSegmentoConta = await verificarSegmentoConta({ 
            segmento: projeto?.segmento, 
            revendaId: projeto?.revenda_id || projeto?.revenda?.id || undefined, 
            distribuidorId: projeto?.distribuidor_id || projeto?.distribuidor?.id || undefined
        });
        if (!validarSegmentoConta) return;

        handleGetProjetos({...filterState, id_projeto: projeto.id});

        const urlsFromTipoEdicao: {[index: string]: string} = {
            vertical: `/projetos/${projeto?.id}/verticais/edicao`,
            personalizado: `/projetos/${projeto.id}/edicao`,
            dimensionado: `/projetos/${projeto.id}/edicao`,
            kit: `/projetos/${projeto?.id}/kits/edicao`
        }

        const urlsFromTipoEdicaoOffGrid: {[index: string]: string} = {
            dimensionado: `/projetos/${projeto?.id}/offgrid/edicao`,
            personalizado: `/projetos/${projeto?.id}/personalizado_offgrid/edicao`,
        }

        const urlsFromTipoEdicaoHibrido: {[index: string]: string} = {
            dimensionado: `/projetos/${projeto?.id}/hibrido/edicao`,
            personalizado: `/projetos/${projeto?.id}/personalizado_hibrido/edicao`,
        }

        let obj = urlsFromTipoEdicao;

        if (projeto?.segmento.includes("offgrid")) {
            obj = urlsFromTipoEdicaoOffGrid;
        }

        if (projeto?.codigo_venda.includes("HIBRI")) {
            obj = urlsFromTipoEdicaoHibrido;
        }
        const urlEdit = obj[projeto?.tipo] || `/projetos/${projeto?.id}/edicao`;

        formState$.next(DEFAULT_PROJETO);
        projetosOffGridStoreActions.reset()

        adminStore.buscarProjeto(projeto?.id, true).then((resp) => {
            if (resp?.length) history.push(urlEdit);
        });
    },[history])

    const renderFiltros = () => {
        return (
            <Grid container size={12}>
                <div className="X12 M4">
                    <InputText
                        onKeyPress={handleKeyPress}
                        label={"Código do projeto"}
                        fullWidth={true}
                        value={filterState.codigo_projeto}
                        onChange={(value: any) => {
                            handleFilterChange({...filterState, codigo_projeto: value.target.value});
                        }}
                    />
                </div>
                <div className="X12 M4">
                    <InputText
                        onKeyPress={handleKeyPress}
                        label={"Título do projeto"}
                        fullWidth={true}
                        value={filterState.titulo}
                        onChange={(value: any) => {
                            handleFilterChange({...filterState, titulo: value.target.value});
                        }}
                    />
                </div>

                <div className="X12 M4">
                    <InputComboBoxList
                        id={`list-segmento`}
                        key={`list-segmento`}
                        label={"Segmento"}
                        textField="text"
                        valueField="value"
                        options={SEGMENTO_LIST}
                        autoComplete
                        value={filterState.segmentos}
                        onChange={(value: any) => {
                            handleFilterChange({...filterState, segmentos: value});
                        }}
                        renderOptions={(option: any) => {
                            return `${option.text}`
                        }}
                        renderOptionsLabel={(option: any) => {
                            return `${option.text}`
                        }}
                    />
                </div>
                <div className="X12 M4">
                    <InputComboBoxList
                        id={`list-situacao-pagamento`}
                        key={`list-situacao-pagamento`}
                        label={"Status de pagamento"}
                        textField="text"
                        valueField="value"
                        options={SITUACAO_PAGAMENTOS_LIST}
                        autoComplete
                        value={filterState.situacao}
                        onChange={(value: any) => {
                            handleFilterChange({...filterState, situacao: value});
                        }}
                        renderOptions={(option: any) => {
                            return `${option.text}`
                        }}
                        renderOptionsLabel={(option: any) => {
                            return `${option.text}`
                        }}
                    />
                </div>

                <div className="X12 M4">
                    <InputComboBoxList
                        multiple
                        id={`list-etapas-vendas`}
                        key={`list-etapas-vendas`}
                        label={"Etapa de Venda"}
                        textField="text"
                        valueField="value"
                        options={ETAPAS_LIST}
                        //options={ETAPA_VENDA}
                        autoComplete
                        value={filterState.etapa_venda}
                        onChange={(value: any[]) => {
                            handleFilterChange({...filterState, etapa_venda: value});
                        }}
                        renderOptions={(option: any) => {
                            return `${option.text}`
                        }}
                        renderOptionsLabel={(option: any) => {
                            return `${option.text}`
                        }}
                    />
                </div>

                <div className="X12 M4">
                    <FlatButton
                        endIcon={
                            <Icon>
                            </Icon>
                        }
                        text={"Filtro avançado"}
                        onClick={() => {
                            setFilterBarIsOpened(true)
                        }}
                        variant={isMobile ? "outlined" : "text"}
                        fullWidth={isMobile}
                        style={isMobile ? { marginTop: 20 } : {}}
                    />
                    <FlatButton
                        color={"primary"}
                        text={"Buscar"}
                        variant={"contained"}
                        onClick={handleSearch}
                        fullWidth={isMobile}
                        style={isMobile ? { margin: "15px 0px" } : {}}
                    />
                    <Button 
                        onClick={handleCleanFilter}  
                        style={isMobile ? {marginBottom: 15, color: '#fff', background: 'rgb(255 174 0)'} : {marginLeft: '10px', color: '#fff', background: 'rgb(255 174 0)'}} 
                        variant="outlined"
                        fullWidth={isMobile}
                    >
                        Limpar filtros
                    </Button>
                </div>
            </Grid>
        )
    }

    const cardMobile = (projeto:any, pedido: any, pagamentos: any[], pagamentoHistorico: any[], nf: any, projetoV1: Projeto, editedByIntb: boolean, criado_em: string, turnkey: boolean) => {
        if (!projeto) return;
        
        return (
            <Card style={{ marginBottom: 20 }}>
                <SugestaoAcoes projeto={projeto} handleAcao={(acao: AcoesSugeridas, projeto: Projeto)=>{
                    setProjetoIdAcoes(projeto?.id as number);
                    handleSugestao(acao, projeto);
                }}
                />
                <CardHeader subheader={
                    <Box>
                        <Grid container size={12} className="row-card-mobile">
                            <Box>
                                <AvatarTipo 
                                    codigo_venda={projeto.codigo_venda}
                                />
                            </Box>
                            <Box style={{ paddingLeft: 10 }} className="row-card-mobile">
                                <Typography
                                    style={{
                                        marginTop: 0,
                                        fontWeight: 'normal',
                                        color: '#212121',
                                        fontSize: 16
                                    }}
                                >
                                    {projeto?.codigo_venda}
                                </Typography>

                                <CopyToClipboard text={projeto.codigo_venda || ""}
                                    onCopy={() => {
                                        setCopied(projeto?.codigo_venda || "")
                                        setTimeout(()=>{setCopied(false)},900)
                                    }}>
                                        <Typography style={{ margin:"0px 5px 0px 12px", cursor: "pointer", fontSize: 18 }}>
                                            <FontAwesomeIcon icon={faCopy} color="#5F5F5F"/>
                                        </Typography>
                                </CopyToClipboard>
                                {(copied === projeto?.codigo_venda) ? 
                                    <Box style={
                                        {
                                            color: "#f7fcf9",
                                            background:"#00af39",
                                            border: "1px solid #00af39",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 10px gray",
                                            fontSize: 12
                                        }
                                    }>Copiado!</Box> : null
                                }
                            </Box>
                        </Grid>
                        <Grid container size={12}>
                            <Box>
                                <Typography
                                    style={{
                                        fontWeight: 'normal',
                                        color: '#757575',
                                        fontSize: 14,
                                        paddingBottom: 5
                                    }}
                                >
                                    {projeto?.titulo}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid container size={12} style={{ textAlign: 'left' }}>
                            <Box>
                                <Button
                                    disabled 
                                    aria-label="settings" 
                                    style={{
                                        color: '#fff', 
                                        background: parseStatusProjetos(projeto?.status_projeto,"cor"), 
                                        borderRadius: '20px',
                                        marginBottom: 5
                                    }}
                                    >
                                    {parseStatusProjetos(projeto?.status_projeto,"texto")}
                                </Button>

                                {projeto?.componentes_finame?.length > 0 && <Button
                                    disabled 
                                    variant="contained"
                                    disableElevation
                                    color="primary"
                                    aria-label="settings" 
                                    style={{
                                        color: "#fff",
                                        background: theme.palette.primary.main,
                                        borderRadius: '20px',
                                        marginBottom: 5,
                                        marginLeft: 5
                                    }}
                                    >
                                    FINAME
                                </Button>}

                                {projeto?.etapa_venda === 'sla_engenharia' && projeto?.revisoes &&
                                    <Button aria-label="settings" style={{
                                        color: "#fff",
                                        background: theme.palette.primary.main,
                                        borderRadius: '20px',
                                        marginBottom: 5,
                                        marginLeft: 5
                                    }}>
                                        Em revisão
                                    </Button>
                                }
                            </Box>
                        </Grid>
                    </Box>}
                />
                <CardContent style={{ paddingBottom: 0, paddingTop: 0 }}>
                    <Grid container size={12} style={{ textAlign: 'left' }}>
                        <Box style={{ padding: "0px 10px" }}>
                            <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                <Box style={{ fontWeight: 'bold' }}>Cliente: </Box>
                                <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{projeto?.cliente_proposta || '-'}</Box>
                            </Grid>

                            <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                <Box style={{ fontWeight: 'bold' }}>Potência: </Box>
                                {projeto?.potencia ? (<Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{(projeto?.potencia).toFixed(2) || "-"}{projeto?.potencia && " kWp"}</Box>) : "-"}
                            </Grid>

                            <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                <Box style={{ fontWeight: 'bold' }}>Valor Total: </Box>
                                <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{handleValorTotal(projeto, pedido)}</Box>
                            </Grid>

                            <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 10, paddingTop: 5 }}>
                                {validadePropostaMobile(projeto, pedido)}
                            </Grid>
                        </Box>
                        
                        <Box className="row-mobile" style={{ paddingTop: 10 }}>
                            <Box>
                                <Button
                                    aria-label="settings"
                                    disabled={!checarStatusDetalhesProjeto(projeto, permissoes)}
                                    onClick={() => {
                                        handleDetailDetalhes(projeto?.id);
                                    }}>
                                    <FontAwesomeIcon icon={faEye} style={{ marginRight: 5 }} /> DETALHES
                                </Button>
                            </Box>

                            <Box>
                                <Button aria-label="settings" color="primary" 
                                    disabled={!checarStatusEditarProjeto(projeto, permissoes, pedido) || projeto.bloqueio_edicao}
                                    onClick={ () => onClickEdit(projeto)}>
                                    <FontAwesomeIcon icon={faPencil} style={{ marginRight: 5 }} /> EDITAR
                                </Button>
                            </Box>

                            <Box>
                                <Button aria-label="settings" 
                                    disabled={!checarStatusAcoesProjeto(projeto)}
                                    style={checarStatusAcoesProjeto(projeto) ? { color: 'rgb(255 174 0)' } : {}}
                                    onClick={(el) => {
                                        handleClickPopoverAcao(el, projeto?.id);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faListDots} style={{ marginRight: 5 }} /> AÇÕES
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </CardContent>
                {cardMobileOpened === projeto?.id && (<Divider style={{ marginTop: 8 }}/>)}
                <CardActions className="card-mobile-actions">
                    <Collapse key="card-mobile" in={cardMobileOpened === projeto?.id} collapsedSize={60}>
                        {cardMobileOpened !== projeto?.id && (
                            <Box className="row-collpase-mobile" onClick={() => setCardMobileOpened(projeto?.id)}>
                                <Typography style={{ fontWeight: 'bold' }}>
                                    Ver detalhes completo
                                </Typography>
                                <Typography>
                                    <KeyboardArrowDown />
                                </Typography>
                            </Box>
                        )}

                        <Box style={{ padding: "15px 20px 0px 25px" }}>
                            <Grid container size={12} style={{ textAlign: 'left' }}>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Criado em: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                        {maskDate(criado_em || "")}
                                        </Box>
                                </Grid>
                            </Grid>
                            <Grid container size={12} style={{ textAlign: 'left' }}>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Valor dos produtos Intelbras: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{turnkey ? handleValorTotal(projeto, pedido) : Formater.toString(projeto?.valor, TypeRecords.CURRENCY) || "-"}</Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Valor dos produtos com desconto: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{turnkey ? handleValorTotal(projeto, pedido) : handleValorProdutosComDesconto(projeto, pedido)}</Box>
                                </Grid>
                                { turnkey ? (
                                        <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                            <Box style={{ fontWeight: 'bold' }}>Tipo de serviço: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{"TurnKey"}</Box>
                                        </Grid>
                                    ) : (
                                        <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                            <Box style={{ fontWeight: 'bold' }}>Valor do Serviço PIS/COFINS: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{Formater.toString(projeto?.valor_servico_pis_cofins, TypeRecords.CURRENCY) || "-"}</Box>
                                        </Grid>
                                    )
                                }

                            </Grid>
                            <Grid container size={12} style={{ textAlign: 'left' }}>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box>
                                        <Box style={{ fontWeight: 'bold' }}>Pagamento: </Box>
                                        <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                            {(pedido?.pagamentos) ? (
                                                <>
                                                    {
                                                        pagamentoHistorico?.length
                                                            ? parseFormaPagamentoHistorico(pagamentoHistorico[0]?.dados_integracao, "", pedido?.forma_pagamento?.id)
                                                            : parseFormaPagamento(pagamentos)
                                                    }
                                                </>
                                            ) : "-"}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Status de pagamento: </Box>
                                    <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                        {(pedido && projeto) ? (
                                            <>
                                                {formatarStatusPagamento(projeto, pedido)}
                                            </>
                                        ) : "-"}
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Desconto: </Box>
                                    <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{handleDesconto(projeto, pedido) || "-"}</Box>
                                </Grid>
                            </Grid>
                            <Grid container size={12} style={{ textAlign: 'left' }}>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Tooltip placement="bottom-start" title='Data contabilizada a partir da confirmação do pagamento'>
                                        <Box style={{ fontWeight: 'bold' }}>Previsão de faturamento: </Box>
                                    </Tooltip>
                                    <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                        {parsePrevisaoFaturamento(pedido?.data_previsao_faturamento, pedido?.data_pagamento, pedido?.pagamentos)}
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Pedido: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{pedido?.pedido_erp || '-'}</Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Nota fiscal: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{nf?.numero || '-'}</Box>
                                </Grid>
                            </Grid>

                            <Grid container size={12} style={{ textAlign: 'left' }}>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Revenda: </Box>
                                    <Box style={{display: "flex"}}>
                                            {(projeto?.revenda?.cnpj_cpf && projeto?.revenda?.fantasia) ? (<>
                                            {projeto?.segmento?.includes("on") && projeto?.classificacao_revenda?.url ? <>
                                                <Tooltip title={projeto?.classificacao_revenda?.nome || ""}>
                                                    <img alt="classificacao-conta" style={{ marginBottom: '0px', marginRight:"6px", height: "100%", width: "100%", maxWidth: 50 }} 
                                                        src={resolveProtocolUrl(`//${resolveUploadUrl(uploadUrl ? uploadUrl : LocalStorage.get("solar.uploadInfo", true))}${projeto?.classificacao_revenda?.url}`)} 
                                                    />
                                                </Tooltip>
                                            </> :  projeto?.segmento?.includes("on") && projeto?.revenda?.classificacao?.url ? <>
                                                <Tooltip title={projeto?.revenda?.classificacao?.nome || ""}>
                                                    <img alt="classificacao-conta" style={{ marginBottom: '0px', marginRight:"6px", height: "100%", width: "100%", maxWidth: 50 }} 
                                                        src={resolveProtocolUrl(`//${resolveUploadUrl(uploadUrl ? uploadUrl : LocalStorage.get("solar.uploadInfo", true))}${projeto?.revenda?.classificacao?.url}`)} 
                                                    />
                                                </Tooltip>
                                            </> : ""}
                                            <Box>
                                                <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                                    {projeto?.revenda?.fantasia ? projeto?.revenda?.fantasia : "-"}
                                                </Typography>
                                                <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                                    {`CNPJ: ${projeto?.revenda?.cnpj_cpf ? Formater.toString(projeto?.revenda?.cnpj_cpf, TypeRecords.CPF_CNPJ) : "-"}`}
                                                </Typography>
                                            </Box>
                                            </>):"-"}
                                        </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Distribuidor: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                        {(projeto?.distribuidor?.nome && projeto?.distribuidor?.cnpj_cpf) ? (<>
                                        <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                            {projeto?.distribuidor?.nome}
                                        </Typography>
                                        <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                            {`CNPJ: ${Formater.toString(projeto?.distribuidor?.cnpj_cpf,TypeRecords.CPF_CNPJ)}`}
                                        </Typography>
                                        </>) : "-"}                                        
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container size={12} style={{ textAlign: 'left' }}>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Criado por: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                        {projetoV1 ? (projeto?.dados_migracao?.projetoV1?.CriadoPor || projeto?.criador?.nome || '-') : projeto?.criador?.nome || '-'}
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Profissional de Vendas: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{projeto?.ev?.nome || '-'}</Box>
                                </Grid>
                                {projeto?.vendedor_interno?.nome &&(
                                <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                    <Box style={{ fontWeight: 'bold' }}>Vendedor Interno: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{projeto?.vendedor_interno?.nome || '-'}</Box>
                                </Grid>)}
                            </Grid>
                            { (projeto.tipo === 'personalizado' || projeto.tipo === 'kit') && projeto?.tipo_faturamento !== null && projeto?.tipo_faturamento !== undefined &&
                                <Grid container size={12} style={{ textAlign: 'left' }}>
                                    <Grid size={{ xs: 12, md: 4 }} style={{ paddingBottom: 15 }}>
                                        <Box style={{ fontWeight: 'bold' }}>Tipo de faturamento: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                            {
                                                projeto?.tipo_faturamento === 'cliente' ? 'Para cliente final' : 
                                                projeto?.tipo_faturamento === 'integrador' ? 'Para revenda' :
                                                projeto?.tipo_faturamento === 'integrador_cliente' ? 'Operação triangular/Venda à ordem' : '.'
                                            }
                                        </Box>
                                    </Grid>
                                </Grid>
                            }
                        </Box>

                        <Box style={{ paddingLeft: 25, paddingBottom: 5 }}>
                            {projeto?.clonado?.origem?.codigo_venda &&
                                <Box display={"flex"} alignItems="center" style={{ marginBottom: 15 }}>
                                    <FontAwesomeIcon icon={faClone} style={{marginRight: 5, background: '#ffffff', color: 'green' }} />
                                    <Box style={{ color: 'green', margin: 0 }} component='p'>Projeto clonado de {projeto.clonado.origem.codigo_venda}</Box>
                                </Box>
                            }
                            {editedByIntb &&
                                <Box display={"flex"} alignItems="center" style={{ marginBottom: 15 }}>
                                    <FontAwesomeIcon icon={faInfoCircle} style={{marginRight: 5, background: '#ffffff', color: 'green' }} />
                                    <Box style={{ color: 'green', margin: 0 }} component='p'>Projeto editado pela Intelbras</Box>
                                </Box>
                            }
                        </Box>

                        {cardMobileOpened === projeto?.id && (
                            <Box className="row-collpase-mobile" onClick={() => setCardMobileOpened(null)}>
                                <Typography style={{ fontWeight: 'bold' }}>
                                    Ocultar detalhes completos
                                </Typography>
                                <Typography>
                                    <KeyboardArrowUp />
                                </Typography>
                            </Box>
                        )}
                    </Collapse>
                </CardActions>
            </Card>
        );
    }

    return (
        <>
            <Box className="root-cards">
                {isMobile ? (
                    <Collapse key="card-filtro-mobile" in={filterMobileOpened} collapsedSize={60}>
                        <Paper className="box-filtros" elevation={1}>
                            <Box className="row-filtros" onClick={() => setFilterMobileOpened(!filterMobileOpened)}>
                                <Typography style={{ fontWeight: 'bold' }}>
                                    <FontAwesomeIcon icon={faFilter} style={{ marginRight: 5 }} color="#00a63e" /> Filtros de busca
                                </Typography>
                                <Typography>
                                    {filterMobileOpened ? <KeyboardArrowUp /> : <KeyboardArrowDown /> }
                                </Typography>
                            </Box>

                            <Box mt={2}>
                                {renderFiltros()}
                            </Box>
                        </Paper>
                    </Collapse>
                ) : renderFiltros()}
            </Box>
            
            <Box>
                {!projetosListagem?.length && !openLoader && (
                    <Empty message="Não há registros" />
                )}

                {projetosListagem?.map((projeto: any) => {
                    const pedido = projeto?.pedidos[0];
                    const historicoList = pedido?.pagamentos_historico?.length ? [...pedido.pagamentos_historico] : []
                    const pagamentoHistorico = historicoList.sort(CollectionUtil.singleSort('-data_atualizacao_pagamento'))
                    const migradoMultiplosPagamentos = (projeto?.migrado && pedido?.pagamentos?.length > 1);
                    let listaPagamentos = migradoMultiplosPagamentos
                        ? pedido?.pagamentos?.filter((i:any) => !["cancelado", "recusado"]?.includes(i?.situacao)) 
                        : pedido?.pagamentos;
                    if (migradoMultiplosPagamentos && !listaPagamentos?.length) listaPagamentos = pedido?.pagamentos?.slice(-1);
                        
                    const nf = pedido?.notas_fiscais?.find((a: any) => a.situacao === 'ativa')
                    const editedByIntb = checkEditedByIntelbras(projeto);
                    const projetoV1 = (projeto?.migrado || projeto?.origem === "V1");
                    const criado_em = projetoV1 ? projeto?.data_criacao : projeto?.created_at;
                    const turnkey = projeto?.tipo === 'vertical' && projeto?.servico === 'intelbras';

                    return (
                        <>
                            { isMobile 
                                ? cardMobile(projeto, pedido, listaPagamentos, pagamentoHistorico, nf, projetoV1, editedByIntb, criado_em, turnkey)
                                : (
                                    <Card style={{ marginBottom: 20 }}>
                                        <SugestaoAcoes projeto={projeto} handleAcao={(acao: AcoesSugeridas, projeto: Projeto)=>{
                                            setProjetoIdAcoes(projeto?.id as number);
                                            handleSugestao(acao, projeto);
                                        }}/>
                                        <CardHeader style={{ display: 'flex', textAlign: 'left' }}
                                            action={<Box>
                                                <Button
                                                    aria-label="settings"
                                                    disabled={!checarStatusDetalhesProjeto(projeto, permissoes)}
                                                    onClick={() => {
                                                        handleDetailDetalhes(projeto?.id);
                                                    }}>
                                                    <FontAwesomeIcon icon={faEye} style={{ marginRight: 5 }} /> DETALHES
                                                </Button>
                                                
                                                <Button aria-label="settings" color="primary" 
                                                    disabled={!checarStatusEditarProjeto(projeto, permissoes, pedido) || projeto.bloqueio_edicao}
                                                    onClick={ () => onClickEdit(projeto)}>
                                                    <FontAwesomeIcon icon={faPencil} style={{ marginRight: 5 }} /> EDITAR
                                                </Button>
                                                
                                                <Button aria-label="settings" 
                                                    disabled={!checarStatusAcoesProjeto(projeto)}
                                                    style={checarStatusAcoesProjeto(projeto) ? { color: 'rgb(255 174 0)' } : {}}
                                                    onClick={(el) => {
                                                        handleClickPopoverAcao(el, projeto?.id);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faListDots} style={{ marginRight: 5 }} /> AÇÕES
                                                </Button>
                                            </Box>}
                                            subheader={<>
                                                <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                    <Box>
                                                        <AvatarTipo 
                                                            codigo_venda={projeto.codigo_venda}
                                                        />
                                                    </Box>
                                                    <Box style={{paddingLeft:"10px"}}>
                                                        <Typography
                                                            style={{
                                                                fontWeight: 'normal',
                                                                marginTop: '0px',
                                                                color: '#212121',
                                                                fontSize: 16
                                                            }}
                                                        >
                                                            {projeto?.codigo_venda}
                                                        </Typography>
                                                        <Button
                                                            disabled 
                                                            aria-label="settings" 
                                                            style={{color: '#fff', 
                                                                    background: parseStatusProjetos(projeto?.status_projeto,"cor"), 
                                                                    margin: '-32px 0px 0px 165px', 
                                                                    float: 'left', 
                                                                    borderRadius: '20px' }}
                                                            >
                                                            {parseStatusProjetos(projeto?.status_projeto,"texto")}
                                                        </Button>
                                                        {projeto?.componentes_finame?.length > 0 && <Button
                                                            disabled 
                                                            variant="contained"
                                                            disableElevation
                                                            color="primary"
                                                            aria-label="settings" 
                                                            style={{
                                                                    color: "#fff",
                                                                    background: theme.palette.primary.main,
                                                                    margin: '-32px 0px 0px 10px', 
                                                                    float: 'left', 
                                                                    borderRadius: '20px' }}
                                                            >
                                                            FINAME
                                                        </Button>}
                                                        <Typography
                                                            style={{
                                                                fontWeight: 'normal',
                                                                color: '#757575',
                                                                fontSize: 14,
                                                                paddingTop: "10px"
                                                            }}
                                                        >
                                                            {projeto?.titulo}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </>}
                                            />                            
                                        <CardContent>
                                            <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                <Grid size={{ xs: 6, md: 4 }}>                                    
                                                    <Box style={{ fontWeight: 'bold' }}>Potência Gerador (kWp): </Box>
                                                    {projeto.tipo === tipoAvulso ? "-" : (projeto?.potencia ? (<Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{(projeto?.potencia).toFixed(2) || "-"}</Box>) : "-")}
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Valor Total: </Box>
                                                    <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{handleValorTotal(projeto, pedido)}</Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Criado em: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                        {maskDate(criado_em || "")}
                                                        </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Valor dos produtos Intelbras: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{turnkey ? handleValorTotal(projeto, pedido) : Formater.toString(projeto?.valor, TypeRecords.CURRENCY) || "-"}</Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Valor dos produtos com desconto: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{turnkey ? handleValorTotal(projeto, pedido) : handleValorProdutosComDesconto(projeto, pedido)}</Box>
                                                </Grid>
                                                { turnkey ? (
                                                        <Grid size={{ xs: 6, md: 4 }}>
                                                            <Box style={{ fontWeight: 'bold' }}>Tipo de serviço: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{"TurnKey"}</Box>
                                                        </Grid>
                                                    ) : (
                                                        <Grid size={{ xs: 6, md: 4 }}>
                                                            <Box style={{ fontWeight: 'bold' }}>Valor do Serviço PIS/COFINS: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{Formater.toString(projeto?.valor_servico_pis_cofins, TypeRecords.CURRENCY) || "-"}</Box>
                                                        </Grid>
                                                    )
                                                }

                                            </Grid>
                                            <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box>
                                                        <Box style={{ fontWeight: 'bold' }}>Pagamento: </Box>
                                                        <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                            {(pedido?.pagamentos) ? (
                                                                <>
                                                                    {
                                                                        pagamentoHistorico?.length
                                                                            ? parseFormaPagamentoHistorico(pagamentoHistorico[0]?.dados_integracao, "", pedido?.forma_pagamento?.id)
                                                                            : parseFormaPagamento(listaPagamentos)
                                                                    }
                                                                </>
                                                            ) : "-"}
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Status de pagamento: </Box>
                                                    <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                        {(pedido && projeto) ? (
                                                            <>
                                                                {formatarStatusPagamento(projeto, pedido)}
                                                            </>
                                                        ) : "-"}
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Desconto: </Box>
                                                    <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{handleDesconto(projeto, pedido) || "-"}</Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Tooltip placement="bottom-start" title='Data contabilizada a partir da confirmação do pagamento'>
                                                        <Box style={{ fontWeight: 'bold' }}>Previsão de faturamento: </Box>
                                                    </Tooltip>
                                                    <Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                        {parsePrevisaoFaturamento(pedido?.data_previsao_faturamento, pedido?.data_pagamento, pedido?.pagamentos)}
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Pedido: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{pedido?.pedido_erp || '-'}</Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Nota fiscal: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{nf?.numero || '-'}</Box>
                                                </Grid>
                                            </Grid>

                                            <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Cliente: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)', wordBreak: 'break-word' }}>{projeto?.cliente_proposta || '-'}</Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Revenda: </Box>
                                                    <Box style={{display: "flex"}}>
                                                            {(projeto?.revenda?.cnpj_cpf && projeto?.revenda?.fantasia) ? (<>
                                                            {projeto?.segmento?.includes("on") && projeto?.classificacao_revenda?.url ? <>
                                                                <Tooltip title={projeto?.classificacao_revenda?.nome || ""}>
                                                                    <img alt="classificacao-conta" width="42px" style={{ marginBottom: '0px', marginRight:"6px"}} 
                                                                        src={resolveProtocolUrl(`//${resolveUploadUrl(uploadUrl ? uploadUrl : LocalStorage.get("solar.uploadInfo", true))}${projeto?.classificacao_revenda?.url}`)} 
                                                                    />
                                                                </Tooltip>
                                                            </> :  projeto?.segmento?.includes("on") && projeto?.revenda?.classificacao?.url ? <>
                                                                <Tooltip title={projeto?.revenda?.classificacao?.nome || ""}>
                                                                    <img alt="classificacao-conta" width="42px" style={{ marginBottom: '0px', marginRight:"6px"}} 
                                                                        src={resolveProtocolUrl(`//${resolveUploadUrl(uploadUrl ? uploadUrl : LocalStorage.get("solar.uploadInfo", true))}${projeto?.revenda?.classificacao?.url}`)} 
                                                                    />
                                                                </Tooltip>
                                                            </> : ""}
                                                            <Box>
                                                                <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                                                    {projeto?.revenda?.fantasia ? projeto?.revenda?.fantasia : "-"}
                                                                </Typography>
                                                                <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                                                    {`CNPJ: ${projeto?.revenda?.cnpj_cpf ? Formater.toString(projeto?.revenda?.cnpj_cpf, TypeRecords.CPF_CNPJ) : "-"}`}
                                                                </Typography>
                                                            </Box>
                                                            </>):"-"}
                                                        </Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Distribuidor: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                        {(projeto?.distribuidor?.nome && projeto?.distribuidor?.cnpj_cpf) ? (<>
                                                        <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                                            {projeto?.distribuidor?.nome}
                                                        </Typography>
                                                        <Typography style={{fontFamily:"inherit", fontSize:"inherit", color:"#777777"}}>
                                                            {`CNPJ: ${Formater.toString(projeto?.distribuidor?.cnpj_cpf,TypeRecords.CPF_CNPJ)}`}
                                                        </Typography>
                                                        </>) : "-"}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Criado por: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                        {projetoV1 ? (projeto?.dados_migracao?.projetoV1?.CriadoPor || projeto?.criador?.nome || '-') : projeto?.criador?.nome || '-'}
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Profissional de Vendas: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{projeto?.ev?.nome || '-'}</Box>
                                                </Grid>
                                                {projeto?.vendedor_interno?.nome &&(
                                                <Grid size={{ xs: 6, md: 4 }}>
                                                    <Box style={{ fontWeight: 'bold' }}>Vendedor Interno: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{projeto?.vendedor_interno?.nome || '-'}</Box>
                                                </Grid>)}
                                            </Grid>
                                            { (projeto.tipo === 'personalizado' || projeto.tipo === 'kit') && projeto?.tipo_faturamento !== null && projeto?.tipo_faturamento !== undefined &&
                                                <Grid container size={12} style={{ textAlign: 'left', padding: '0px 0px 20px' }}>
                                                    <Grid size={{ xs: 6, md: 4 }}>
                                                        <Box style={{ fontWeight: 'bold' }}>Tipo de faturamento: </Box><Box component="span" style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                            {
                                                                projeto?.tipo_faturamento === 'cliente' ? 'Para cliente final' : 
                                                                projeto?.tipo_faturamento === 'integrador' ? 'Para revenda' :
                                                                projeto?.tipo_faturamento === 'integrador_cliente' ? 'Operação triangular/Venda à ordem' : '.'
                                                            }
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            }
                                        </CardContent>

                                        <CardActions style={{ paddingTop: 0, paddingLeft: 16, display: "flex", alignItems: "flex-start", flexDirection: "column" }} >
                                            {projeto?.clonado?.origem?.codigo_venda &&
                                                <Box display={"flex"} alignItems="center" marginLeft={'0 !important'}>
                                                    <FontAwesomeIcon icon={faClone} style={{marginRight: 5, background: '#ffffff', color: 'green' }} />
                                                        <Box style={{ color: 'green' }} component='p'>Projeto clonado de {projeto.clonado.origem.codigo_venda}</Box>
                                                </Box>
                                            }
                                            {editedByIntb &&
                                                <Box display={"flex"} alignItems="center" marginLeft={'0 !important'}>
                                                    <FontAwesomeIcon icon={faInfoCircle} style={{marginRight: 5, background: '#ffffff', color: 'green' }} />
                                                    <Box style={{ color: 'green' }} component='p'>Projeto editado pela Intelbras</Box>
                                                </Box>
                                            }
                                            {projeto?.etapa_venda === 'sla_engenharia' && projeto?.revisoes &&
                                                <Box display={"flex"} alignItems="center" marginLeft={'0 !important'}>
                                                    <Button aria-label="settings" style={{color: '#fff', background: 'green', borderRadius: '20px'  }}>
                                                        Em revisão
                                                    </Button>
                                                </Box>
                                            }
                                        </CardActions>
                                        {validadeProposta(projeto, pedido)}
                                    </Card>
                                )
                            }
                        </>
                    );
                })}

                { openPopoverAcao &&
                    <Popover
                        open={openPopoverAcao}
                        anchorEl={anchorAcao}
                        onClose={handleClosePopover}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <div className='popover-acao'>
                            <div className='popover-acao-body' >
                                { getAcoes() }
                            </div>
                        </div>
                    </Popover>
                }
            </Box>
            
            <FilterDrawer
                close={() => setFilterBarIsOpened(false)}
                isOpened={filterBarIsOpened}
                filters={filterState} 
                setFilters={data => handleFilterChange({...filterState, ...data})}
                handleSearch={handleSearch}
            />

            { projetosEstate &&
                <TablePagination
                    className="cards-paginacao"
                    component="div"
                        style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    count={projetosEstate?.infoRows?.count || 0}
                    page={filterState.page || DEFAULT_PAGE}
                    rowsPerPageOptions={[10, 15, 25]}
                    onPageChange={handleChangePage}
                    rowsPerPage={filterState.pageSize || DEFAULT_PAGE_SIZE}
                    onRowsPerPageChange={handleChangePageSize}
                    labelRowsPerPage={"Registros por página:"}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count} registros`}
                />
            }
            
            { openModalDetalhes &&
                <ModalDetalhes 
                    open={openModalDetalhes}
                    setOpenModal={handleOpenModalDetalhes}
                    projetoId={projetoId}
                ></ModalDetalhes>
            }
            { (openConfirmaVisita && idProjetoVisita) && (
                <ConfirmarVisita 
                    open={openConfirmaVisita}
                    onClose={()=>{setOpenConfirmaVisita(false)}}
                    onSuccess={handleSearch}
                    idprojeto={idProjetoVisita}
                />
            )}

            {!!openFinalizarProjetoRenovigiProjetoIdModal && (
                <ModalFinalizarProjetoManual
                    open={!!openFinalizarProjetoRenovigiProjetoIdModal}
                    closeModal={() => setOpenFinalizarProjetoRenovigiProjetoIdModal(0)}
                    onSuccess={handleSearch}
                    projetoId={openFinalizarProjetoRenovigiProjetoIdModal}
                />
            )}

            { openModalAlterarServico &&
                <ModalAlterarServico
                    open={openModalAlterarServico}
                    setOpenModal={handleOpenModalAlterarServico}
                    projeto={currentProjeto}
                    onSuccess={handleSearch}
                ></ModalAlterarServico>
            }

            { openModalFinalizar &&
                <ModalFinalizar
                    open={openModalFinalizar}
                    setOpenModal={handleOpenModalFinalizar}
                    projeto={currentProjeto}
                    onSuccess={handleSearch}
                ></ModalFinalizar>
            }

            { openModalCancelarProjeto &&
                <ModalCancelarProjeto
                    open={openModalCancelarProjeto}
                    setOpenModal={handleOpenModalCancelarProjeto}
                    projeto={currentProjeto}
                    onSuccess={handleSearch}
                ></ModalCancelarProjeto>
            }

            { openModalCancelamentoEspecial &&
                <ModalCancelamentoEspecial
                    open={openModalCancelamentoEspecial}
                    closeModal={() => setOpenModalCancelamentoEspecial(false)}
                    projeto={currentProjeto}
                    onSuccess={handleSearch}
                />
            }

            { openModalAtualizarEntrega &&
                <ModalAtualizarEntrega
                    open={openModalAtualizarEntrega}
                    closeModal={() => setOpenModalAtualizarEntrega(false)}
                    projeto={currentProjeto}
                />
            }

            { openModalClonarProjeto &&
                <ModalClonarProjeto
                    open={openModalClonarProjeto}
                    closeModal={() => setOpenModalClonarProjeto(false)}
                    projeto={currentProjeto}
                    onSuccess={handleSearch}
                />
            }

            { openModalReenviarNotaFiscal &&
                <ModalReenviarNotaFiscal
                    open={openModalReenviarNotaFiscal}
                    closeModal={() => setOpenModalReenviarNotaFiscal(false)}
                    projeto={currentProjeto}
                    onSuccess={() => {
                        notifierStore.setNotifier({
                            content: "Nota fiscal reenviada com sucesso!",
                            title: "Sucesso",
                            onClose: () => {
                                notifierStore.setOpen(false)
                            },
                            onFinishTimeout: () => {
                                notifierStore.setOpen(false)
                            },
                            timeOut: 5000,
                        })

                        notifierStore.setOpen(true)
                
                    }}
                />
            }

            { (openEnviarNota && idProjetoNota) && (
                <EnviarNota 
                    open={openEnviarNota}
                    onClose={()=>{setOpenEnviarNota(false)}}
                    idProjeto={idProjetoNota}
                    onSuccess={handleSearch}
                    pedido={currentProjeto?.pedidos[0]}
                />
            )}

            { (openModalVisualizarProposta) && (
                <ModalVisualizarProposta
                tipo={tipoVisualizacaoProposta}
                open={openModalVisualizarProposta}
                setOpenModal={handleOpenModalVisualizarProposta}
                projeto={currentProjeto}
            ></ModalVisualizarProposta>
            )}

            { openModalReativarProposta && (
                <ModalReativarProposta
                open={openModalReativarProposta}
                setOpenModal={handleOpenModalReativarProposta}
                projeto={currentProjeto}
                onSuccess={handleSearch}
                reativar={reativarProjeto}
            ></ModalReativarProposta>
            )}

            { openModalDesconto &&
                <ModalAplicarDesconto
                    openModal={openModalDesconto}
                    onClose={() => setOpenModalDesconto(false)}
                    projeto={currentProjeto}
                    onSuccess={handleSearch}
                ></ModalAplicarDesconto>
            }

            { openEnviarPagamento && (
                <EnviarPagamento 
                    onClose={()=>setOpenEnviarPagamento(false)}
                    open={openEnviarPagamento}
                    idprojeto={idProjetoPagamento}
                    onSuccess={handleSearch}
                />
            )}

            { openModalEnviarDocumentosServico &&
                <ModalEnviarDocumentosServico
                    openModal={openModalEnviarDocumentosServico}
                    onClose={() => setOpenModalEnviarDocumentosServico(false)}
                    projeto={currentProjeto}
                    onSuccess={handleSearch}
                ></ModalEnviarDocumentosServico>
            }

            {revendaComServicoDesabilitadoWarningModal.status && (
                <ModalRevendaServicoDesabilitado 
                    closeModal={() => setRevendaComServicoDesabilitadoWarningModal({ status: false, onConfirm: () => {}, idProjeto: null })}
                    isOpen={revendaComServicoDesabilitadoWarningModal.status}
                    onConfirm={() => {
                        revendaComServicoDesabilitadoWarningModal.onConfirm()
                        handleSearch();
                    }}
                    idProjeto={revendaComServicoDesabilitadoWarningModal.idProjeto}
                />
            )}

            {tipoPropostaModalIsOpened && <TipoPropostaModal
                isOpened={tipoPropostaModalIsOpened}
                close={() => setTipoPropostaModalIsOpened(false)}
                onConfirm={async (tipoProposta) => {
                    if (!currentProjeto) return;

                    const temPermissaoDeProposta = PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissoes) || PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes)
                    let wppMessage = temPermissaoDeProposta ? (mensagemWhatsAppProposta || '') : '';

                    if (currentProjeto.segmento.includes("vertical")) {
                        wppMessage = ''
                    }

                    const url = WhatsAppUtil.montarUrlProposta(tipoProposta, currentProjeto?.codigo_venda || '', currentProjeto?.telefone_proposta, wppMessage || '')
                    
                    window.open(url, "_blank", "noopener,noreferrer");
                    setTipoPropostaModalIsOpened(false)
                
                    await projetosProvider.registrarEnvioPropostaWhatsapp(currentProjeto?.id || 0, 'menu-acoes')
                }}
            />}

            {openLoader && (
                <CustomLoader 
                    loading={openLoader}
                />
            )}
        </>
    );
}

export { Cards }
